/**
 * 작성자 : 한영광
 * 날짜 : 2024.09.05
 * 경로 : 방송 장비 관리 > 방송 장비 음원 / 스케줄 설정 탭
 */

/**
 * 수정자 : 박승호
 * 날짜 : 2024.09.06
 * 기능 : 화면 UI 작업
 */

/**
 * 수정자 : 홍선영
 * 날짜 : 2025.04.17
 * 기능 : 화면 UI 작업
 */

// @ts-ignore

import React, { Dispatch, SetStateAction, useEffect, useMemo, useRef, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import { userState } from '../../../atoms';
import { useSetAuth } from '../../../utils/useSetAuth';
import { useFetchCommonCodeList } from '../../../services/useSetCodeListInSelectBoxForm';
import { COMCD_USE_YN, DETECT_EVENT_LIST, INIT_END_HMS, INIT_START_HMS, INIT_USE_YN_A, INIT_WEEK_LIST, MOBILE_NOT_SUPPORT } from '../../../_constants';
import { BroadcastPlanScheme, IDaySchedule, IModal, IWeekSchedule, PlanScheme, Schedule, Time, WeeklySchedule, WeeklyScheduleInfo } from 'customTypes';
import { apiGet, apiPatch } from '../../../services/_common';
import { useQuery } from '@tanstack/react-query';
import i18n from '../../../translation/i18n';
import { PulseLoader } from 'react-spinners';
import IssueGuide from '../../../components/IssueGuide';
import Portal from '../../../components/Portal';
import { BtnBlue, BtnGhost, BtnGreen, BtnRed } from '../../../components/Button';
import useOnKeydownF9 from '../../../utils/useOnKeydownF9';
import { ContentsContainerRoot } from '../../../assets/styles/ContentsContainerRoot';
import { LoadingModalBackground } from '../../../assets/styles/Modal';
import { useOutletContext } from 'react-router-dom';
import { ButtonsWrapper } from '../../sm_setting/setting7/cctvInfoStyle';
import { TuiGridTwoColumnStyle } from '../../../assets/styles/TuiGridTwoColumnStyle';
import TableInfoMoal from '../../../components/Modal/TableInfoModal';
import { WebSDKspeaker } from '../../../utils/webSDKspeakerClass';
import WebSdkModal from '../../../components/Modal/WebSdkModal';
import { toast } from 'react-toastify';
import Input from '../../../components/Input';
import { applyBorderStyle } from '../../../utils/applyBorderStyle';
import RadioContainer from '../../../components/button/RadioContainer';
import RangePicker, { onChangeRangeInput } from '../../../components/RangePicker';
import { parseTime, todayYYYYMMDD } from '../../../utils/formatDate';
import dayjs from 'dayjs';
import BsSettingCopyModal from '../../../components/Modal/BsSettingCopyModal';
import SliderSettings from '../../sm_setting/setting12/SliderSettings';
import CustomTimePicker from '../../../components/CustomTimePicker';
import { v4 } from 'uuid';
import { logPost } from '../../../services/log';
import { isMobile } from '../../../utils/checkMobile';
import LoadButton from '../../../components/button/LoadButton';
import TextInfoBox from '../../../components/TextInfoBox';
import SpeakerAudioInfoModal from '../../../components/Modal/SpeakerAudioInfoModal';
import { InputTable } from '../../../assets/styles/InputTable';
import CheckBoxCircle from '../../../components/button/CheckBoxCircle';
import styled from 'styled-components';
import SmallTextLabel from '../../../components/button/SmallTextLabel';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { TouchBackend } from 'react-dnd-touch-backend';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { createPortal } from 'react-dom';
import FullScreenLoading from '../../../components/FullScreenLoading';
import DeleteModal from '../../../components/Modal/DeleteModal2';
import ConfirmModal from '../../../components/Modal/ConfirmModal';

const DraggableRow = ({ type, el, auth, index, moveRow, tableState, setTableState, onClickRow, selectedKey, setAudioPlayList }: any) => {
  const trRef = useRef(null);
  const { t } = useTranslation();
  const userInfo = useRecoilValue(userState);
  const newCdArray = tableState.map((elParam: any) => elParam.cdSort);
  const cdSortArray = newCdArray.sort((a: number, b: number) => a - b);

  const onClickRemove = () => {
    const tableArray = [...tableState];
    tableArray.splice(index, 1);
    setTableState(tableArray);

    const audioPlayList = tableArray.map((audio: any) => new Audio(audio.bsfFurl));
    setAudioPlayList(audioPlayList);
  };

  const [, drop] = useDrop({
    accept: 'ROW',
    hover(item: any, monitor) {
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }
      moveRow(tableState, setTableState, dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
    drop: (item, monitor) => {
      const copyArray = [...tableState];
      const newArray = copyArray.map((cpItem, cpIndex) => ({ ...cpItem, cdSort: cdSortArray[cpIndex], editor: userInfo.userId }));
      setTableState(newArray);

      const audioPlayList = newArray.map((audio: any) => new Audio(audio.bsfFurl));
      setAudioPlayList(audioPlayList);
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: 'ROW',
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(trRef));

  return (
    <div ref={trRef} className={`dg-item ${selectedKey && el.tatCd === selectedKey ? 'selected' : ''}`} style={{ opacity: isDragging ? 0 : 1 }} role='presentation' key={el.bsfNameFormat}>
      <div className='dg-left'>
        <span className='material-symbols-rounded'>drag_handle</span>
        <div className='dg-index'>{index + 1}</div>
        <div className='dg-name'>{el.bsfNameFormat}</div>
      </div>
      <BtnRed onClick={onClickRemove} className='dg-remove-btn'>
        <span className='material-symbols-rounded'>remove</span>
      </BtnRed>
    </div>
  );
};

const dragRow = (list: any[], setList: Dispatch<SetStateAction<any[]>>, fromIndex: number, toIndex: number) => {
  const updatedData = [...list];
  const [movedItem] = updatedData.splice(fromIndex, 1);
  updatedData.splice(toIndex, 0, movedItem);
  setList(updatedData);
};

const BroadcastSchedule = () => {
  const toDay = todayYYYYMMDD();
  const emptyPlanRowState = {
    planSchemeID: '',
    planSchemeName: '',
    enabled: true,
    startDate: dayjs(toDay).format('YYYY-MM-DD'),
    endDate: dayjs(toDay).format('YYYY-MM-DD'),
    useDate: true,
  };
  const emptySubPlanRowState = {
    v: '0',
    beginTime: '',
    endTime: '',
    audioVolume: 100,
    audioLevel: 4,
    audioFiles: [],
    playMode: 'order',
  };
  const emptyScheduleTime = {
    startTime: dayjs(toDay).format('YYYY-MM-DD'),
    stopTime: dayjs(toDay).format('YYYY-MM-DD'),
    daily: [],
    wekly: [],
    dateType: 'day', // 'day'(매일) | 'week'(주간)
  };

  const getDayOfWeek = (dayOfWeek: number) => {
    switch (dayOfWeek) {
      case 1:
        return '월요일 ';
      case 2:
        return '화요일 ';
      case 3:
        return '수요일 ';
      case 4:
        return '목요일 ';
      case 5:
        return '금요일 ';
      case 6:
        return '토요일 ';
      case 7:
        return '일요일 ';
    }
    return '';
  };

  const [MUSIC_FILE_INFO, BROAD_SCHEDULE] = [0, 1]; // 음원 파일 목록, 방송 스케줄 정보
  const [INFO_VIEW, COVER_VIEW] = [0, 1]; // 스케줄 정보, 덮어쓰기

  const { t } = useTranslation();
  const { isF9Pressed, setIsF9Pressed } = useOnKeydownF9(); // f9키 프레스 훅
  const { auth } = useSetAuth(); // 사용자 권한값 훅
  const mobile = isMobile();
  const userInfo = useRecoilValue(userState);
  const [openModal, setOpenModal] = useState<any>({ status: false, type: '', data: '', index: 0 });
  const [orgTableState, setOrgTableState] = useState<any[]>([]);
  const size = useOutletContext<any>();
  const [viewTable, setViewTable] = useState<boolean>(true);
  const [selectRowKey, setSelectedRowKey] = useState<any>(null);
  const [rowState, setRowState] = useState<any>(); // 선택된 Row 값
  const [tableState, setTableState] = useState<any[]>([]);
  const [audioFilesTableState, setAudioFilesTableState] = useState<any[]>([]); // 해당 방송 장비 세부 음원 목록
  const [bsFTableState, setBsFTableState] = useState([]);
  const [broadcastTableState, setBroadcastTableState] = useState<PlanScheme[]>([]);
  const [audioFilesColumns, setAudioFilesColumns] = useState<any[]>([]);
  const [checkList, setCheckList] = useState<any[]>([]);
  const [bsList, setBsList] = useState<any>([]);
  const [bsCd, setBsCd] = useState({ type: 'bsCd', bsCd: 'A', cdName: t('전체') });
  const { data: useYnComCdListWithAll } = useFetchCommonCodeList(COMCD_USE_YN, true); // 사용여부 공통코드 목록 (검색조건에서 사용, 전체포함)
  const [searchOptionUseYn, setSearchOptionUseYn] = useState(INIT_USE_YN_A);
  const [rowKey, setRowKey] = useState<string>('');
  const [broadcastRowKey, setBroadcastRowKey] = useState<string>('');
  const [tuiHeight, setTuiHeight] = useState<null | number>(null);
  const [activeTab, setActiveTab] = useState(BROAD_SCHEDULE); // 하위메뉴의 내부탭 액티브상태값
  const [speakerObj, setSpeakerObj] = useState<WebSDKspeaker | null>(null);
  const [storage, setStorage] = useState({ capacity: 0, freeSpace: 0 });
  const [mainLoading, setMainLoading] = useState(false);
  const [subLoading, setSubLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [copyModalLoading, setCopyModalLoading] = useState(false);

  const [planRowState, setPlanRowState] = useState<any>(emptyPlanRowState); // 선택된 예약 정보
  const [initPlanRowState, setInitPlanRowState] = useState<any>(emptyPlanRowState); // 선택된 예약 정보
  const [isSaveClick, setIsSaveClick] = useState<boolean>(false);
  const [useDateType, setUseDateType] = useState<boolean>(true); // true = 매일, false = 주간
  const [visibleRangePicker, setVisibleRangePicker] = useState(false);
  const [rangeState, setRangeState] = useState([{ startDate: new Date(), endDate: new Date(), key: 'selection' }]);
  const [dateTime, setDateTime] = useState<any>({ wName: '', start: toDay, end: toDay });
  const [isUseYn, setIsUseYn] = useState<boolean>(true);
  const [subPlanRowData, setSubPlanRowData] = useState<any>(emptySubPlanRowState);
  const [filterAudioFiles, setFilterAudioFiles] = useState<any[] | null>(null);
  const planSchemeNameRef = useRef();
  const broadRef = useRef<any>();

  const [audioCheckList, setAudioCheckList] = useState<any[]>([]); // 방송 스케줄 - 음원 파일 추가 목록 체크 리스트
  const [audioPlayList, setAudioPlayList] = useState<HTMLAudioElement[]>([]);
  const [scheduleTimeList, setScheduleTimeList] = useState<any>(emptyScheduleTime); // 스케줄 목록 리스트
  const [scheduleChkList, setScheduleChkList] = useState([]); // 음원 파일 체크 리스트

  const [timeList, setTimeList] = useState<{ timeId: String; beginTime: Time; endTime: Time }[]>([{ timeId: v4(), beginTime: INIT_START_HMS, endTime: INIT_START_HMS }]); // 스케줄 시간 목록
  const [selectedTimeStart, setSelectedTimeStart] = useState<Time>(INIT_START_HMS); // 시작 시간
  const [selectedTimeEnd, setSelectedTimeEnd] = useState<Time>(INIT_START_HMS); // 종료 시간
  const [timeCycleType, setTimeCycleType] = useState<'hour' | 'minute'>('hour'); // 구간 주기 타입 ( 시간/분 )
  const [timeCycle, setTimeCycle] = useState<number>(1); // 범위 주기 ( 마다 )
  const [timeCycleMinute, setTimeCycleMinute] = useState<number>(1); // 범위 주기 ( 씩 ) ( 분 단위 )
  const [isCycleMode, setIsCycleMode] = useState<boolean>(false);
  const [availableTime, setAvailableTime] = useState<[{ start: Time; end: Time }]>([{ start: INIT_START_HMS, end: INIT_END_HMS }]);
  const [availableTimeRange, setAvailableTimeRange] = useState<{ start: Time; end: Time }>({ start: INIT_START_HMS, end: INIT_END_HMS });
  const [selectedDayOfWeek, setSelectedDayOfWeek] = useState<number | null>(null); // 클릭한 그리드 요일 상태값
  const [isNewBroadcast, setIsNewBroadcast] = useState<boolean>(true); // 스케줄그룹 신규여부
  const [isNewSchedule, setIsNewSchedule] = useState<boolean>(true); // 시간별스케줄 신규여부
  const [isActionLoading, setIsActionLoading] = useState<{ isSave: boolean; isDelete: boolean; isCover: boolean }>({ isSave: false, isDelete: false, isCover: false }); // 저장, 삭제, 덮어쓰기 로딩 여부
  const [settingCopyTableState, setSettingCopyTableState] = useState<any[]>([]);
  const [loadSpeakerData, setLoadSpeakerData] = useState<any>();
  const [scheuleMusicAddColumns, setScheuleMusicAddColumns] = useState<any>([]);
  const [eventDetectList, setEventDetectList] = useState(DETECT_EVENT_LIST);
  const [speakerList, setSpeakerList] = useState<{ index: number; connectValue: number; checked: boolean }[]>([{ index: 0, connectValue: 0, checked: false }]);
  const [scheduleGroupList, setScheduleGroupList] = useState<{ type: 'schedule'; schedule: string; cdName: string }[]>([]);
  const [selectedScheduleGroup, setSelectedScheduleGroup] = useState({ type: 'schedule', schedule: '', cdName: '' });
  const [schedules, setSchedules] = useState<{ type: 'schedule'; schedule: ''; cdName: '' }[]>([]);
  const [weekList, setWeekList] = useState(INIT_WEEK_LIST);
  const scheduleInfoKey = useDateType ? 'dailyScheduleInfo' : 'weklyScheduleInfo';
  const scheduleListKey = useDateType ? 'dailyScheduleList' : 'weeklyScheduleList';
  const [canConnect, setCanConnect] = useState(true);

  const [currentView, setCurrentView] = useState(INFO_VIEW); // 현재 보여지는 우측 화면 상태값
  const [checkAll, setCheckAll] = useState(false); // 덮어쓰기 - 방송장비 목록 전체 체크 여부
  const [coverCheckList, setCoverCheckList] = useState<any[]>([]); // 덮어쓰기 - 방송장비 목록 체크 리스트

  const MAX_SCHEDULE_COUNT = 10;
  const MAX_TIME_COUNT = useDateType ? MAX_SCHEDULE_COUNT : 5;
  const MAX_AUDIO_COUNT = 5;

  // 알림 설정 조회
  const { data: detectAudioList, refetch: detectAudioListRefetch } = useQuery(
    ['detectAudioList', userInfo.hCd, userInfo.sCd, rowState?.bsCd],
    () => apiGet({ path: '/bs/alarmconfig', req: { hCd: userInfo.hCd, sCd: userInfo.sCd, bsCd: rowState?.bsCd } }),
    {
      enabled: !!userInfo.hCd && !!userInfo.sCd && userInfo.sCd !== '00000' && !!rowState && !!rowState?.bsCd,
    }
  );

  const bsQuery = useQuery(['bs', userInfo], () => apiGet({ path: '/bs', req: { hCd: userInfo.hCd, sCd: userInfo.sCd } }), {
    enabled: !!userInfo.hCd && !!userInfo.sCd && userInfo.sCd !== '00000' && !!speakerObj,
  });

  // 음원 정보 조회
  const { data: bsfList } = useQuery(['bsfList', userInfo], () => fetchData(), {
    enabled: !!userInfo.hCd && !!userInfo.sCd && userInfo.sCd !== '00000',
  });

  const [DBbsfList, setDBbsfList] = useState<any[]>([]);
  const Backend = mobile ? TouchBackend : HTML5Backend;

  useEffect(() => {
    if (bsfList) setDBbsfList(bsfList);
  }, [bsfList]);

  const musicAddColumns = useMemo(
    () => [
      {
        header: t('음원명'),
        name: 'bsfNameFormat',
        align: 'left',
        sortable: true,
        minWidth: 240,
        renderer: { classNames: ['text_secondary'] },
      },
      {
        header: t('파일크기'),
        name: 'bsfFsizeMb',
        align: 'center',
        sortable: true,
        width: 80,
        renderer: { classNames: ['text_secondary'] },
      },
      {
        header: t('재생시간'),
        name: `bsfDuration`,
        align: 'center',
        sortable: false,
        width: 100,
      },
      {
        header: t('비고'),
        name: `bigo`,
        align: 'center',
        sortable: false,
        width: 80,
      },
    ],
    [t]
  );

  // 방송장비 목록 데이터패치 함수
  const fetchData = async () => {
    try {
      const res = await apiGet({ path: '/bs/bsf', req: { hCd: userInfo.hCd, sCd: userInfo.sCd } });
      const result = res.data.data;
      const newArray = result?.map((el: any) => {
        return {
          ...el,
          useYnCdName: el.useYn === 'Y' ? t('사용') : t('미사용'),
          bsfNameFormat: `${el.bsfName}.${el.audioType}`,
          bsfFsizeMb: `${el.bsfFsize}MB`,
          bsfDuration: el.bsfFtime.match(/.{1,2}/g).join(':'),
          format: el.bsfFurl.slice(-3, el.bsfFurl.length),
          customAudioID: el.bsfCd,
        };
      });
      return newArray;
    } catch (error) {
      console.error('error', error);
      throw new Error('error');
    }
  };

  useEffect(() => {
    if (isF9Pressed) {
      onClickSearch();
      setIsF9Pressed(false);
    }
  }, [isF9Pressed]);

  useEffect(() => {
    setActiveTab(BROAD_SCHEDULE);
    setBroadcastRowKey('');
    setPlanRowState(emptyPlanRowState);
  }, [rowKey]);

  useEffect(() => {
    setBsFTableState(bsfList);
  }, [bsfList]);

  useEffect(() => {
    setAudioFilesColumns(scheuleMusicAddColumns);
  }, [i18n.language, audioFilesTableState]);

  useEffect(() => {
    if (bsQuery.isSuccess && bsQuery.data.status === 200) {
      const { data } = bsQuery.data.data;
      const newData = data.filter((el: any) => el.useYn === 'Y');
      const newArray = newData.map((el2: any) => ({ type: 'bsCd', bsCd: el2.bsCd, cdName: el2.bsName }));
      connCheckBsInfos(newData.map((el: any) => ({ ...el, useYnCdName: el.useYn === 'Y' ? '사용' : '미사용', storageRes: [], broadcastsRes: [] })));
      setBsList([{ type: 'bsCd', bsCd: 'A', cdName: t('전체') }, ...newArray]);
      setSpeakerList(newData.map((el: any, i: number) => ({ ...el, index: i, connectValue: 0, checked: false })));
    }
  }, [bsQuery.isSuccess, bsQuery.isRefetching]);

  useEffect(() => {
    setSubLoading(true);
    setStorage({ capacity: 0, freeSpace: 0 });
    setCheckList([]);

    if (rowState?.isConnFail) setSubLoading(false);
    // else fetchSpeakerInfo(rowState);
  }, [rowState, detectAudioList]);

  useEffect(() => {
    const websdkSpeaker = new WebSDKspeaker({ setOpenModal });
    websdkSpeaker?.init();
    setSpeakerObj(websdkSpeaker);
  }, []);

  useEffect(() => {
    if (!rangeState[0].startDate) {
      return;
    }
    setDateTime((prev: any) => ({ ...prev, start: dayjs(rangeState[0].startDate).format('YYYY-MM-DD') }));
  }, [rangeState[0].startDate]);

  useEffect(() => {
    if (!rangeState[0].endDate) {
      return;
    }
    setDateTime((prev: any) => ({ ...prev, end: dayjs(rangeState[0].endDate).format('YYYY-MM-DD') }));
  }, [rangeState[0].endDate]);

  useEffect(() => {
    if (loadSpeakerData && tableState[loadSpeakerData.index]?.bsIp === rowState?.bsIp && tableState[loadSpeakerData.index]?.pPort === rowState?.pPort) {
      setStorage(tableState[loadSpeakerData.index]?.storageRes || []);
      setBroadcastTableState(tableState[loadSpeakerData.index]?.broadcastsRes || []);

      if (tableState[loadSpeakerData.index]?.broadcastsRes?.length > 0) {
        const newScheduleList = tableState[loadSpeakerData.index]?.broadcastsRes.map((item: any) => ({ type: 'schedule', schedule: item.planSchemeID, cdName: item.planSchemeID }));
        setScheduleGroupList(newScheduleList);
        // setSelectedScheduleGroup(newScheduleList[0]); // 예약방송 목록이 존재하는 경우 의 첫번째 스케줄 자동선택
        // setIsNewBroadcast(false);
      } else {
        setScheduleGroupList([]);
        setSelectedScheduleGroup({ type: 'schedule', schedule: '', cdName: '' });
        setIsNewBroadcast(true);
        initFn();
        // onClickNewAdd('newAdd');
        // setPlanRowState(emptyPlanRowState);
      }
    }
  }, [loadSpeakerData, rowState, speakerObj]);

  const connCheckBsInfos = async (bsInfos: any[]) => {
    setMainLoading(true);
    const newBsInfos: any[] = [];
    await Promise.allSettled(
      bsInfos.map(async (bsInfo) => {
        await speakerObj
          ?.reqConnCheck({ ip: bsInfo.bsIp, port: bsInfo.pPort, id: bsInfo.bsId, pwd: bsInfo.bsPwd })
          .then(() => {
            newBsInfos.push({ ...bsInfo, isConnFail: false, connectValue: 1, checked: false });
          })
          .catch(() => {
            newBsInfos.push({ ...bsInfo, isConnFail: true, connectValue: 3, checked: false });
          });
      })
    );
    setTableState(newBsInfos.sort((a, b) => Number(a.bsCd) - Number(b.bsCd)));
    setOrgTableState(newBsInfos.sort((a, b) => Number(a.bsCd) - Number(b.bsCd)));
    setSpeakerList(newBsInfos);
    setMainLoading(false);
  };

  useEffect(() => {
    setScheuleMusicAddColumns([
      {
        header: t('음원명'),
        name: 'bsfName',
        align: 'left',
        sortable: true,
        minWidth: 120,
        renderer: { classNames: ['text_secondary'] },
      },
      {
        header: t('알림 종류'),
        name: 'detectEvent',
        align: 'center',
        sortable: true,
        minWidth: 80,
      },
      {
        header: t('형식'),
        name: 'audioType',
        align: 'center',
        sortable: true,
        minWidth: 80,
        renderer: { classNames: ['text_secondary'] },
      },
      {
        header: t('파일크기'),
        name: `bsfFsize`,
        align: 'center',
        sortable: false,
        width: 80,
      },
      {
        header: t('재생시간'),
        name: `bsfFtime`,
        align: 'center',
        sortable: false,
        width: 100,
      },
    ]);
  }, [i18n.language]);

  const fetchSpeakerInfo = async (_rowState: any) => {
    try {
      const [storageRes, broadcastsRes] = await Promise.all([
        speakerObj?.reqGetStorageSizeAPI({ ip: _rowState.bsIp, port: _rowState.pPort, id: _rowState.bsId, pwd: _rowState.bsPwd }),
        speakerObj?.reqGetBroadcastAPI({ hCd: userInfo.hCd, sCd: userInfo.sCd, bsCd: _rowState.bsCd, ip: _rowState.bsIp, port: _rowState.pPort, id: _rowState.bsId, pwd: _rowState.bsPwd }),
      ]);

      let updateStateNum;

      const newTableState = tableState.map((v, i) => {
        if (v.bsIp === _rowState.bsIp && v.pPort === _rowState.pPort) {
          updateStateNum = i;
          return {
            ...v,
            storageRes,
            broadcastsRes,
          };
        }
        return {
          ...v,
        };
      });

      const findRow = newTableState.find((el: any) => el.bsCd === _rowState.bsCd);
      if (findRow) {
        const auidoFiles = findRow.audioFilesRes || [];
        const newMap = auidoFiles?.map((el: any) => {
          return {
            ...el,
            detectEvent: el.bsfCd === detectAudioList?.data?.data?.fireAudio?.bsfCd ? '화재감지' : el.bsfCd === detectAudioList?.data?.data?.helmetAudio?.bsfCd ? '안전모 미착용' : '',
          };
        });
        setAudioFilesTableState(newMap);
      }
      setTableState(newTableState);
      setLoadSpeakerData({
        index: updateStateNum,
        storageRes,
        broadcastsRes,
      });

      setSubLoading(false);
      // 모든 상태 업데이트가 완료된 후
      setCanConnect(true);
      return { storageRes, broadcastsRes };
    } catch (error) {
      console.error(error);
      throw new Error('방송 장비 연결에 실패했습니다.');
    }
  };

  // 스케줄그룹 정보 세팅
  const setScheduleGroupInfo = (scheduleInfoType: 'dailyScheduleInfo' | 'weklyScheduleInfo', group: PlanScheme) => {
    const formatStartDate = group[scheduleInfoType]?.startTime ? new Date(group[scheduleInfoType]!.startTime) : new Date();
    const formatEndDate = group[scheduleInfoType]?.stopTime ? new Date(group[scheduleInfoType]!.stopTime) : new Date();

    setRangeState((prev: any) => [{ ...prev[0], startDate: formatStartDate, endDate: formatEndDate }]);
    setIsUseYn(group.enabled);
    setUseDateType(scheduleInfoType === 'dailyScheduleInfo');
  };

  // 스케줄그룹 선택했을 때 스케줄 목록 세팅
  useEffect(() => {
    if (selectedScheduleGroup.schedule !== '' && broadcastTableState.length > 0 && DBbsfList.length > 0) {
      const findIndex = scheduleGroupList.findIndex((item) => item.schedule === selectedScheduleGroup.schedule); // 여기 문제
      if (findIndex !== -1) {
        const scheduleType = broadcastTableState[findIndex].dailyScheduleInfo ? 'dailyScheduleInfo' : 'weklyScheduleInfo';
        formatScheduleList(scheduleType, broadcastTableState[findIndex]);
        setScheduleGroupInfo(scheduleType, broadcastTableState[findIndex]);
        setSubPlanRowData({
          ...subPlanRowData,
          audioFiles: DBbsfList,
          // customAudioID: ,
        });
      }
      // setIsNewBroadcast(false);
    }
  }, [selectedScheduleGroup.schedule, broadcastTableState, DBbsfList]);

  // 스케줄그룹 목록 셀렉트박스형태로 변환
  const formatScheduleGroupList = (scheduleGroupRes: PlanScheme[]) => {
    const sGroupList: any[] = scheduleGroupRes.map((schedule: PlanScheme) => ({ type: 'schedule', schedule: '', cdName: schedule.planSchemeID }));
    setScheduleGroupList(sGroupList);
    // 스케줄그룹 0번째 자동 선택
    /*
    if (sGroupList?.length > 0) {
      setSelectedScheduleGroup(sGroupList[0]);
      setIsNewBroadcast(false);
    }
    */
  };

  const formatScheduleList = (scheduleType: 'dailyScheduleInfo' | 'weklyScheduleInfo', scheduleData: PlanScheme) => {
    let list: any = [];
    if (scheduleType === 'dailyScheduleInfo') {
      const dailyScheduleList = scheduleData.dailyScheduleInfo?.dailyScheduleList;
      list = dailyScheduleList;
    } else if (scheduleType === 'weklyScheduleInfo') {
      const weeklyScheduleList = scheduleData.weklyScheduleInfo?.weeklyScheduleList.flatMap(({ dayOfWeek, scheduleList }: any) => scheduleList.map((schedule: any) => ({ ...schedule, dayOfWeek })));
      list = weeklyScheduleList;
    }
    const formattedSchedules = list?.map((item: any) => ({
      type: 'schedule',
      schedule: `${getDayOfWeek(item.dayOfWeek)}${item.beginTime?.substring(0, 5)} - ${item.endTime?.substring(0, 5)}`,
      cdName: `${getDayOfWeek(item.dayOfWeek)}${item.beginTime?.substring(0, 5)} - ${item.endTime?.substring(0, 5)}`,
    }));
    const addDefaulSelect: any[] = [{ type: 'schedule', schedule: '', cdName: '신규 등록' }, ...formattedSchedules];
    setSchedules(addDefaulSelect);
  };

  // 방송 장비 목록 Row 클릭
  const onClickSpeakerRow = async (rowData: any, idx: number) => {
    // 초기화
    setIsNewBroadcast(true);
    setSelectedScheduleGroup({ type: 'schedule', schedule: '', cdName: '' });
    setCheckAll(false);
    setCurrentView(INFO_VIEW);
    initFn();

    if (rowData.connectValue === 0) {
      toast.warning(t('방송 장비 연결 중입니다.'));
      return;
    }

    if (rowData.connectValue === 3) {
      toast.error(t('연결에 실패한 방송 장비입니다.'));
      return;
    }

    setCanConnect(false);

    if (rowData) {
      const { broadcastsRes } = await fetchSpeakerInfo(rowData);
      setRowKey(idx.toString());
      setRowState(rowData);
      setViewTable(false);
      setSettingCopyTableState(tableState.filter((table: any) => table.bsCd !== rowData.bsCd && !table.isConnFail));

      if (broadcastsRes) {
        setBroadcastTableState(broadcastsRes);
        formatScheduleGroupList(broadcastsRes);
      }
    }
  };

  // 검색버튼 클릭 이벤트
  const onClickSearch = () => {
    const searchFilter = { bsCd: bsCd.bsCd, useYn: searchOptionUseYn[COMCD_USE_YN] };
    const filteredData = orgTableState.filter((item: any) => {
      return Object.entries(searchFilter).every(([key, filterValue]) => {
        if (filterValue === 'A') return true; // 필터 값이 'A'이면 기준 무시 (return true)
        return item[key] === filterValue; // 그렇지 않으면 항목의 속성이 필터의 속성과 일치하는지 확인
      });
    });
    setTableState(filteredData);
    setRowKey('');
    setRowState(undefined);
  };

  // 초기화 버튼 클릭
  const onClickInitiateSearchOption = () => {
    initiateSearchOptions();
    setTableState(orgTableState);
    setRowKey('');
    setRowState(undefined);
  };

  const initiateSearchOptions = () => {
    setBsCd({ type: 'bsCd', bsCd: 'A', cdName: t('전체') });
    setSearchOptionUseYn(INIT_USE_YN_A);
  };

  const onClickRangeInput = () => {
    if (!visibleRangePicker) setVisibleRangePicker(true);
  };

  // 설정 복사 클릭
  const onClickCopy = () => {
    setCurrentView(COVER_VIEW);
    setSelectedScheduleGroup({ type: 'schedule', schedule: '', cdName: '' });

    /*
    if (!subLoading) {
      if (tableState.find((el) => el.bsCd === rowState.bsCd)?.isConnFail) {
        toast.error(t('연결에 실패한 방송 장비입니다.'));
      } else {
        setSelectedScheduleGroup({ type: 'schedule', schedule: '', cdName: '' });
        setCurrentView(COVER_VIEW);
      }
    }
    */
  };

  const [copyState, setCopyState] = useState({
    totalCount: 0,
    currentCount: 0,
    bsName: '',
    currentContent: '',
  });

  const copySetting = async (bsInfoList: any[]) => {
    setIsActionLoading((prev) => ({ ...prev, isCover: true }));

    await bsInfoList
      .reduce((promise, bsInfo, index) => {
        const { bsName, bsCd: bsInfoBsCd, bsIp: ip, pPort: port, bsId: id, bsPwd: pwd } = bsInfo;
        return promise
          .then(() => {
            setCopyState({
              totalCount: bsInfoList.length,
              currentCount: index + 1,
              bsName: bsInfo.bsName,
              currentContent: t('방송 장비 초기화'),
            });
            // return speakerObj?.reqPostInitAPI({ hCd: userInfo.hCd, sCd: userInfo.sCd, ip, port, id, pwd });
          })
          .then(() => {
            setCopyState({
              totalCount: bsInfoList.length,
              currentCount: index + 1,
              bsName: bsInfo.bsName,
              currentContent: t('스케줄 복사'),
            });
            return speakerObj?.reqPostBroadcastAPI({
              hCd: userInfo.hCd,
              sCd: userInfo.sCd,
              bsCd: bsInfoBsCd,
              ip,
              port,
              id,
              pwd,
              broadcastPlanSchemeList: broadcastTableState || [],
            });
          });
      }, Promise.resolve())
      .then(async () => {
        setIsActionLoading((prev) => ({ ...prev, isCover: false }));
        toast.success(t('복사 완료'));
        await fetchSpeakerInfo(rowState);

        logPost({
          hCd: userInfo.hCd,
          sCd: userInfo.sCd,
          userId: userInfo.userId,
          menu: '방송 장비 관리 / 스케줄 설정',
          action: '덮어쓰기',
          etc: rowState.bsName,
        });
      })
      .catch(() => {
        setIsActionLoading((prev) => ({ ...prev, isCover: false }));
        toast.error(t('복사 실패'));
      });
  };

  // 음원 삭제 Confirm
  const onClickDeleteConfirm = (activeTabParam: number) => {
    setOpenModal({
      status: true,
      type: 'delete',
      // state: tableState,
      // setState: setTableState,
      api: () => onClickDelete(activeTabParam),
    });
  };

  // 음원 삭제
  const onClickDelete = async (activeTabParam: number) => {
    if (activeTabParam === 1) {
      if (isActionLoading.isSave) toast.warning(t('방송 스케줄이 저장중입니다'));
      else {
        setIsActionLoading((prev) => ({ ...prev, isDelete: true }));
        try {
          const resultArray = broadcastTableState.filter((plan: PlanScheme) => plan.planSchemeID !== selectedScheduleGroup.schedule);
          const broadcastsRes = await speakerObj?.reqPostBroadcastAPI({
            hCd: userInfo.hCd,
            sCd: userInfo.sCd,
            bsCd: rowState.bsCd,
            ip: rowState.bsIp,
            port: rowState.pPort,
            id: rowState.bsId,
            pwd: rowState.bsPwd,
            broadcastPlanSchemeList: resultArray,
          });
          if (broadcastsRes && broadcastsRes.data.statusCode === 200) {
            toast.success(t('삭제 완료되었습니다'));
            const newMap = broadcastsRes.data.data.map((el: any) => ({ type: 'schdeulde', schedule: el.planSchemeID, cdName: el.planSchemeID }));
            setBroadcastRowKey('');
            setScheduleGroupList(newMap);
            setPlanRowState(emptyPlanRowState);
            setInitPlanRowState(emptyPlanRowState);
            setBroadcastTableState(broadcastsRes.data.data || []);
            initFn();
            // onClickNewAdd('newAdd');
            setIsActionLoading((prev) => ({ ...prev, isDelete: false }));

            // 스케줄 그룹 목록에서 제거 후 0번째 스케줄그룹 선택
            // const deleteScheduleGroup = scheduleGroupList.filter((item) => item.schedule !== selectedScheduleGroup.schedule);
            // setScheduleGroupList(deleteScheduleGroup);

            // setIsNewBroadcast(true);
            // setIsNewSchedule(true);
            // setUseDateType(true);
            // setIsUseYn(true);
            // setRangeState([{ startDate: new Date(), endDate: new Date(), key: 'selection' }]);
            // setAudioFilesTableState([]);

            // 남은 스케줄 그룹이 없으면 스케줄 그룹 선택 탭으로 이동
            setSelectedScheduleGroup({ type: 'schedule', schedule: '', cdName: '' });
            // setSelectedScheduleGroup(deleteScheduleGroup[0] || { type: 'schedule', schedule: '', cdName: '' });
          }
        } catch (err) {
          toast.error(t('삭제에 오류가 발생했습니다'));
          setIsActionLoading((prev) => ({ ...prev, isDelete: false }));
        }
      }
    } else if (activeTabParam === 3) {
      const reqObjKey = useDateType ? 'dailyScheduleInfo' : 'weklyScheduleInfo';
      const reqArrayKey = useDateType ? 'dailyScheduleList' : 'weeklyScheduleList';
      const customObjKey = useDateType ? 'daily' : 'wekly';
      let setArr = [];

      if (isActionLoading.isSave) toast.warning(t('해당 스케줄이 저장중입니다'));
      else {
        setIsActionLoading((prev) => ({ ...prev, isDelete: true }));

        if (subPlanRowData.id) {
          if (reqObjKey === 'dailyScheduleInfo') {
            setArr = scheduleTimeList[customObjKey].filter((item: any) => item.id !== subPlanRowData.id && item).map((item: any) => setReqScheduleFormat(item));
          } else {
            const newArr = scheduleTimeList[customObjKey].map((item: any) => (item.scheduleList.length === 0 ? false : item)).filter((item: any) => item && item);
            setArr = newArr
              .map((item: any) =>
                item.dayOfWeek.toString() === subPlanRowData.v.toString()
                  ? {
                      ...item,
                      scheduleList: item.scheduleList.filter((_item: any) => _item.id !== subPlanRowData.id && _item).map((_item: any) => setReqScheduleFormat(_item)),
                    }
                  : { ...item, scheduleList: item.scheduleList.map((_item: any) => setReqScheduleFormat(_item)) }
              )
              .filter((item: any) => item.scheduleList.length !== 0 && item);
          }
          const result = {
            ...planRowState,
            planSchemeID: planRowState.planSchemeID?.trim(),
            enabled: isUseYn,
            planSchemeName: planRowState.planSchemeName,
            [reqObjKey]: {
              startTime: dateTime.start,
              stopTime: dateTime.end,
              [reqArrayKey]: setArr,
            },
          };

          try {
            let resultArray;
            if (setArr.length > 0) {
              resultArray = broadcastTableState.map((el: PlanScheme) => (el.planSchemeName === planRowState.planSchemeName ? result : el));
            } else {
              resultArray = broadcastTableState.filter((el: PlanScheme) => el.planSchemeName !== planRowState.planSchemeName);
            }
            const broadcastsRes = await speakerObj?.reqPostBroadcastAPI({
              hCd: userInfo.hCd,
              sCd: userInfo.sCd,
              bsCd: rowState.bsCd,
              ip: rowState.bsIp,
              port: rowState.pPort,
              id: rowState.bsId,
              pwd: rowState.bsPwd,
              broadcastPlanSchemeList: resultArray,
            });

            if (broadcastsRes && broadcastsRes.data.statusCode === 200) {
              toast.success(t('삭제 완료되었습니다'));
              if (setArr.length > 0) {
                setPlanRowState(result);
              } else {
                setPlanRowState(emptyPlanRowState);
                setIsNewBroadcast(true);
              }
              setBroadcastTableState(broadcastsRes.data.data || []);
              setIsNewSchedule(false);
              setIsActionLoading((prev) => ({ ...prev, isDelete: false }));

              logPost({
                hCd: userInfo.hCd,
                sCd: userInfo.sCd,
                userId: userInfo.userId,
                menu: '방송 장비 음원 / 스케줄 설정',
                action: '삭제',
                etc: planRowState.planSchemeID?.trim(),
              });
            }
          } catch (err) {
            toast.error(t('삭제에 오류가 발생했습니다'));
            setIsActionLoading((prev) => ({ ...prev, isDelete: false }));
          }
        }
      }
    }
  };

  const setTimeFormat = (timeObj: Time) => {
    const arr = [];
    for (const val of Object.values(timeObj)) {
      arr.push(val.toString().padStart(2, '0'));
    }

    return `${arr.join(':')}+08:00`;
  };

  // "HH:MM:SS" 형식의 음원 재생시간 문자열을 초 단위로 변환
  const durationStringToSeconds = (duration: string): number => {
    const [h, m, s] = (duration || '00:00:00').split(':').map(Number);
    return (h || 0) * 3600 + (m || 0) * 60 + (s || 0);
  };

  // 선택된 음원 파일들의 총 재생시간(초) - 종료 시간 계산용. 음원과 음원 사이 전환 여유시간(파일당 1초)을 포함 (스케줄이 종료되어 음원이 중간에 끊기는 문제를 방지)
  const getTotalAudioDurationSeconds = () => {
    return audioFilesTableState.reduce((acc: number, file: any) => acc + durationStringToSeconds(file.bsfDuration) + 1, 0);
  };

  // 선택된 음원 파일들의 순수 총 재생시간(초) - "음원 파일 선택"의 총 길이 표기용 (전환 여유시간 미포함)
  const getPureAudioDurationSeconds = () => {
    return audioFilesTableState.reduce((acc: number, file: any) => acc + durationStringToSeconds(file.bsfDuration), 0);
  };

  // 시작 시간에 초를 더한 시간 반환 (자정을 넘어가면 23:59:59로 고정)
  const addSecondsToTime = (time: Time, secondsToAdd: number): Time => {
    const totalSeconds = time.h * 3600 + time.m * 60 + time.s + secondsToAdd;
    if (totalSeconds >= 86400) return { ...INIT_END_HMS };

    return {
      h: Math.floor(totalSeconds / 3600),
      m: Math.floor((totalSeconds % 3600) / 60),
      s: totalSeconds % 60,
    };
  };

  // 디버그용: Time 객체를 'HH:MM:SS' 문자열로 변환
  const timeToHHMMSS = (time: Time) => `${String(time.h).padStart(2, '0')}:${String(time.m).padStart(2, '0')}:${String(time.s).padStart(2, '0')}`;

  // 총 초를 'HH:MM:SS' 문자열로 변환 (음원 총 길이 표기용)
  const secondsToHHMMSS = (totalSeconds: number) => timeToHHMMSS({ h: Math.floor(totalSeconds / 3600), m: Math.floor((totalSeconds % 3600) / 60), s: totalSeconds % 60 });

  // DraggableRow에서 순서변경/삭제로 audioFilesTableState가 바뀌면, 모달 체크상태 비교기준(subPlanRowData.operation.audioFiles)도 동기화
  useEffect(() => {
    setSubPlanRowData((prev: any) => ({ ...prev, operation: { ...prev.operation, audioFiles: audioFilesTableState } }));
  }, [audioFilesTableState]);

  // 한 번만 재생(order) 모드에서 음원 파일 목록이 바뀌면 모든 시간 항목의 종료 시간을 재계산
  useEffect(() => {
    if (subPlanRowData.playMode !== 'order') return;
    const totalDurationSeconds = getTotalAudioDurationSeconds();
    setTimeList((prev: any[]) => prev.map((time) => ({ ...time, endTime: addSecondsToTime(time.beginTime, totalDurationSeconds) })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audioFilesTableState, subPlanRowData.playMode]);

  const onClickWeeklyMode = () => {
    if (timeList.length > 5) {
      setOpenModal((prev: IModal) => ({
        ...prev,
        status: true,
        type: 'weeklyModeConfirm',
        api: () => {
          setTimeList((list: any[]) => list.slice(0, 5));
          setUseDateType(false);
        },
      }));
    } else {
      setUseDateType(false);
    }
  };

  const onClickOrderMode = () => {
    setSubPlanRowData((prev: any) => ({ ...prev, playMode: 'order' }));
    const totalDurationSeconds = getTotalAudioDurationSeconds();
    setTimeList((prev: any[]) =>
      prev.map((time) => ({
        ...time,
        endTime: addSecondsToTime(time.beginTime, totalDurationSeconds),
      }))
    );
  };

  // 예약 스케줄 저장시 포멧 세팅
  const setReqScheduleFormat = (obj: any) => {
    return {
      operation: {
        audioLevel: +obj.operation.audioLevel,
        audioVolume: +obj.operation.audioVolume,
        audioSource: 'customAudio',
        customAudioID: obj.operation.customAudioID,
      },
      playMode: obj.playMode,
      playNowTime: '',
      beginTime: obj.beginTime,
      endTime: obj.endTime,
    };
  };

  // 음원 추가
  const onClickSaveMusicFile = () => {
    setOpenModal((prev: any) => ({ ...prev, status: true, type: 'musicAdd' }));
  };

  // 시작 시간과 선택된 시간을 비교하여 유효성을 확인하는 함수
  const compareTimes = (s: Date, e: Date): boolean => {
    return e.getTime() >= s.getTime();
  };

  const convertTimeToDate = (timeObj: { h: number; m: number; s: number }): Date => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate(), timeObj.h, timeObj.m, timeObj.s);
  };

  const hasSamePlanSchemeName = (planSchemeName: string) => {
    return broadcastTableState.some((el: PlanScheme) => el.planSchemeID?.trim() === planSchemeName?.trim());
  };

  const saveSchedule = async () => {
    // 기존 예외처리
    if (isActionLoading.isDelete) toast.warning(t('해당 스케줄이 삭제중입니다'));
    else if (isNewBroadcast && broadcastTableState.length >= MAX_SCHEDULE_COUNT)
      toast.warn(t(`스케줄은 최대 ${MAX_SCHEDULE_COUNT}개까지 등록 가능합니다. 예약만료된 스케줄을 삭제하거나 수정해서 사용해주세요`));
    else if (planRowState.planSchemeName?.trim() === '') toast.warning(t('스케줄명을 입력하세요'));
    else if (
      (isNewBroadcast && hasSamePlanSchemeName(planRowState.planSchemeName?.trim())) ||
      (!isNewBroadcast && selectedScheduleGroup.schedule !== planRowState.planSchemeName?.trim() && hasSamePlanSchemeName(planRowState.planSchemeName?.trim()))
    )
      toast.warning(t('중복된 스케줄명입니다'));
    else if (dateTime.start.length !== 10 || dateTime.end.length !== 10) toast.warning(t('예약 일자를 확인하세요'));
    else if (!useDateType && weekList.find((item: any) => item.checked) === undefined) {
      toast.warning(t('예약하실 요일을 선택해주세요'));
    } else if (audioFilesTableState.length === 0) {
      toast.warning(t('음원 파일을 추가해주세요'));
    } else {
      // 시간 배열 검증
      const timeValidationResult = validateTimeList();
      if (!timeValidationResult.isValid) {
        toast.warning(timeValidationResult.message);
        return;
      }

      const allDaysSelected = !useDateType && weekList.every((item: any) => item.checked);
      if (allDaysSelected) {
        setOpenModal((modalState: IModal) => ({
          ...modalState,
          status: true,
          type: 'allDaysConfirm',
          api: () => {
            setIsActionLoading((loadingState) => ({ ...loadingState, isSave: true }));
            saveFunction(true);
          },
        }));
      } else {
        setIsActionLoading((prev) => ({ ...prev, isSave: true }));
        saveFunction();
      }
    }
  };

  // 시간 배열 검증 함수
  const validateTimeList = () => {
    // 시간을 초 단위로 변환하는 함수
    const timeToSeconds = (time: Time) => {
      return time.h * 3600 + time.m * 60 + time.s;
    };

    // 시간 범위가 겹치는지 확인하는 함수
    const isTimeRangeOverlap = (range1: { start: number; end: number }, range2: { start: number; end: number }) => {
      return range1.start <= range2.end && range1.end >= range2.start;
    };

    const isOrderMode = subPlanRowData.playMode === 'order';
    const totalAudioDurationSeconds = isOrderMode ? getTotalAudioDurationSeconds() : 0;

    // 각 시간 항목 검증
    for (let i = 0; i < timeList.length; i += 1) {
      const currentTime = timeList[i];
      const currentStart = timeToSeconds(currentTime.beginTime);
      const currentEnd = timeToSeconds(currentTime.endTime);

      if (isOrderMode) {
        // order 모드: 시작 시간 + 음원 재생시간이 자정을 넘어가는 경우 (시작=종료가 되는 경우 포함)
        if (currentStart + totalAudioDurationSeconds >= 86400) {
          return {
            isValid: false,
            message: t(`${i + 1}번째 시간은 음원 재생 시간이 자정을 넘어갑니다. 시작 시간을 앞당기거나 음원을 줄여주세요.`),
          };
        }
      }

      if (!isOrderMode) {
        // 1. 시작 시간이 종료 시간보다 큰 경우
        if (currentStart >= currentEnd) {
          return {
            isValid: false,
            message: t(`${i + 1}번째 시간의 종료 시간이 시작 시간보다 커야 합니다.`),
          };
        }

        // 2. 시작 시간과 종료 시간이 동일한 경우
        if (currentStart === currentEnd) {
          return {
            isValid: false,
            message: t(`${i + 1}번째 시간의 시작 시간과 종료 시간이 동일합니다.`),
          };
        }
      }

      // 3. 다른 시간 항목들과 비교
      for (let j = i + 1; j < timeList.length; j += 1) {
        const compareTime = timeList[j];
        const compareStart = timeToSeconds(compareTime.beginTime);
        const compareEnd = timeToSeconds(compareTime.endTime);

        if (isOrderMode) {
          // order 모드: 시작 시간 중복 체크
          if (currentStart === compareStart) {
            return {
              isValid: false,
              message: t(`${i + 1}번째와 ${j + 1}번째 시작 시간이 중복됩니다.`),
            };
          }
          // order 모드: 종료 시간이 음원 총 재생시간 기준으로 계산되므로, 다른 시간과 겹치는지 확인
          if (isTimeRangeOverlap({ start: currentStart, end: currentEnd }, { start: compareStart, end: compareEnd })) {
            return {
              isValid: false,
              message: t(`${i + 1}번째와 ${j + 1}번째 시간의 범위가 겹칩니다. 음원 재생시간을 고려하여 시작 시간을 조정해주세요.`),
            };
          }
        } else {
          // 3-1. 완전히 동일한 시간인 경우
          if (currentStart === compareStart && currentEnd === compareEnd) {
            return {
              isValid: false,
              message: t(`${i + 1}번째와 ${j + 1}번째 시간이 중복됩니다.`),
            };
          }

          // 3-2. 시간 범위가 겹치는 경우
          if (isTimeRangeOverlap({ start: currentStart, end: currentEnd }, { start: compareStart, end: compareEnd })) {
            return {
              isValid: false,
              message: t(`${i + 1}번째와 ${j + 1}번째 시간의 범위가 겹칩니다.`),
            };
          }
        }
      }
    }

    return { isValid: true, message: '' };
  };

  const onClickSave = async (activeTabParam: number) => {
    // 1: 방송&스케줄저장
    if (activeTabParam === 1) {
      setIsCycleMode(false);
      await saveSchedule();
    } else if (activeTabParam === 2) {
      setOpenModal((prev: any) => ({ ...prev, status: true, type: 'scheduleMusicAdd' }));
    }
  };

  // 선택한 스케줄그룹의 기존 스케줄 수정
  const amendExistedSchedule = (newSchedule: Schedule[]) => {
    /*
    scheduleList: [
          {
            beginTime: setTimeFormat(selectedTimeStart),
            endTime: setTimeFormat(selectedTimeEnd),
            operation: {
              audioSource: 'customAudio' as 'customAudio',
              customAudioID: audioFilesTableState.map((item: any) => item.customAudioID),
              audioLevel: +subPlanRowData.audioLevel,
              audioVolume: +subPlanRowData.audioVolume,
            },
            playMode: subPlanRowData.playMode || 'order',
            playNowTime: '',
          },
        ],
    */

    // 선택스케줄 수정
    if (scheduleInfoKey === 'weklyScheduleInfo') {
      // 여러개의(복수 선택) 요일 스케줄 처리
      const updateScheduleList = weekList
        .filter((item: any) => item.checked)
        ?.map((item: any) => {
          return {
            dayOfWeek: item.dayOfWeek,
            scheduleList: newSchedule,
          };
        });

      // 선택한 스케줄그룹의 스케줄 수정
      const newBroadcastList = broadcastTableState.map((el: any) => {
        if (el.planSchemeID === planRowState.planSchemeID) {
          return {
            planSchemeID: planRowState.planSchemeName,
            planSchemeName: planRowState.planSchemeName,
            enabled: isUseYn,
            [scheduleInfoKey]: { startTime: dateTime.start, stopTime: dateTime.end, weeklyScheduleList: [updateScheduleList] },
          };
        }
        return el;
      });
      return newBroadcastList;
    }
    {
      const newBroadcastList = broadcastTableState.map((el: any) => {
        if (el.planSchemeID === planRowState.planSchemeID) {
          return {
            planSchemeID: planRowState.planSchemeName,
            planSchemeName: planRowState.planSchemeName,
            enabled: isUseYn,
            [scheduleInfoKey]: { startTime: dateTime.start, stopTime: dateTime.end, dailyScheduleList: [...newSchedule] },
          };
        }
        return el;
      });
      return newBroadcastList;
    }
  };

  // 새 스케줄그룹에 새 스케줄 생성
  const insertNewScheduleGroup = (targetReqScheme: PlanScheme, newSchedule: Schedule[]): PlanScheme[] => {
    if (scheduleInfoKey === 'weklyScheduleInfo') {
      const newList = weekList.map((w) => (w.checked ? { dayOfWeek: w.dayOfWeek, scheduleList: [...newSchedule] } : null)).filter((schedule): schedule is WeeklySchedule => schedule !== null);

      return [
        ...(broadcastTableState || []),
        {
          ...targetReqScheme,
          weklyScheduleInfo: {
            startTime: targetReqScheme.weklyScheduleInfo?.startTime || '',
            stopTime: targetReqScheme.weklyScheduleInfo?.stopTime || '',
            weeklyScheduleList: newList,
          },
        },
      ];
    }

    return [...(broadcastTableState || []), targetReqScheme];
  };

  const saveFunction = async (forceDaily = false) => {
    const actualInfoKey = forceDaily ? 'dailyScheduleInfo' : scheduleInfoKey;
    const actualListKey = forceDaily ? 'dailyScheduleList' : scheduleListKey;
    const { bsCd: rowBsCd, bsIp, bsId, bsPwd, pPort } = rowState;

    const defaultOption = {
      operation: {
        audioSource: 'customAudio' as 'customAudio',
        customAudioID: audioFilesTableState?.map((item: any) => item.customAudioID) || [],
        audioLevel: +subPlanRowData.audioLevel,
        audioVolume: +subPlanRowData.audioVolume,
      },
      playMode: subPlanRowData.playMode || 'order',
      playNowTime: '',
    };

    const computedTimeList =
      subPlanRowData.playMode === 'order'
        ? timeList.map((time) => ({
            ...time,
            endTime: addSecondsToTime(time.beginTime, getTotalAudioDurationSeconds()),
          }))
        : timeList;

    const newSchedule = computedTimeList.map((time: any) => ({
      beginTime: setTimeFormat(time.beginTime),
      endTime: setTimeFormat(time.endTime),
      ...defaultOption,
    }));

    /*
    const newSchedule = {
      beginTime: setTimeFormat(selectedTimeStart),
      endTime: setTimeFormat(selectedTimeEnd),
      operation: {
        audioSource: 'customAudio' as 'customAudio',
        customAudioID: audioFilesTableState?.map((item: any) => item.customAudioID) || [],
        audioLevel: +subPlanRowData.audioLevel,
        audioVolume: +subPlanRowData.audioVolume,
      },
      playMode: subPlanRowData.playMode || 'order',
      playNowTime: '',
    };
    */

    const targetReqScheme: PlanScheme = {
      planSchemeID: planRowState.planSchemeName?.trim(),
      planSchemeName: planRowState.planSchemeName,
      enabled: isUseYn,
      [actualInfoKey]: {
        startTime: dateTime.start,
        stopTime: dateTime.end,
        [actualListKey]: [...newSchedule],
      },
    };

    try {
      const BroadcastPlanSchemeReq: BroadcastPlanScheme = {
        bsCd: rowBsCd,
        ip: bsIp,
        port: pPort,
        id: bsId,
        pwd: bsPwd,
        broadcastPlanSchemeList: (() => {
          if (forceDaily) {
            if (isNewBroadcast) return [...(broadcastTableState || []), targetReqScheme];
            return broadcastTableState.map((el: any) =>
              el.planSchemeID === planRowState.planSchemeID
                ? {
                    planSchemeID: planRowState.planSchemeName,
                    planSchemeName: planRowState.planSchemeName,
                    enabled: isUseYn,
                    dailyScheduleInfo: { startTime: dateTime.start, stopTime: dateTime.end, dailyScheduleList: [...newSchedule] },
                  }
                : el
            );
          }
          return isNewBroadcast
            ? insertNewScheduleGroup(targetReqScheme, newSchedule) // 새 스케줄 생성
            : amendExistedSchedule(newSchedule); // 기존 스케줄 수정
        })(),
      };

      const res = await speakerObj?.reqPostBroadcastAPI({ hCd: userInfo.hCd, sCd: userInfo.sCd, ...BroadcastPlanSchemeReq });
      const { data, statusCode, message } = res.data;
      if (statusCode === 200) {
        toast.success(t(message));
        setBroadcastTableState(data);
        setFilterAudioFiles(null);
        setIsActionLoading((prev) => ({ ...prev, isSave: false }));

        const newMap = data.map((el: any) => ({ type: 'schedule', schedule: el.planSchemeID, cdName: el.planSchemeID }));
        setScheduleGroupList(newMap);

        // 신규 스케줄 생성 시 마지막 스케줄 선택
        if (isNewBroadcast) {
          const lastSchedule = data[data.length - 1];
          setSelectedScheduleGroup({ type: 'schedule', schedule: lastSchedule.planSchemeID, cdName: lastSchedule.planSchemeID });
          onClickSchedule(lastSchedule);
        } else {
          const currentSchedule = data.find((el: any) => el.planSchemeID === targetReqScheme.planSchemeName);
          setSelectedScheduleGroup({ type: 'schedule', schedule: currentSchedule.planSchemeName, cdName: currentSchedule.planSchemeName });
          onClickSchedule(currentSchedule);
        }

        // if (isNewBroadcast) {
        // 예약 방송명 목록 추가, 해당방송 선택
        // setScheduleGroupList((prev: any) => [...prev, { type: 'schedule', schedule: req.planSchemeName, cdName: req.planSchemeName }]);
        // setSelectedScheduleGroup({ type: 'schedule', schedule: req.planSchemeName, cdName: req.planSchemeName });
        // }

        logPost({
          hCd: userInfo.hCd,
          sCd: userInfo.sCd,
          userId: userInfo.userId,
          menu: '방송 장비 관리 / 스케줄 설정',
          action: `${isNewBroadcast ? '신규' : '수정'}`,
          etc: `${planRowState.planSchemeID?.trim()}`,
        });
      } else {
        // toast.error(t(message));
      }
    } catch (error) {
      console.error(error);
      toast.error(t('저장에 문제가 발생했습니다'));
      const uncheck = speakerList.map((el: any) => ({ ...el, checked: false }));
      setSpeakerList(uncheck);
    } finally {
      setIsActionLoading((prev) => ({ ...prev, isSave: false }));
    }
  };

  // 초기화 함수
  const initFn = () => {
    setCurrentView(INFO_VIEW);
    setSelectedScheduleGroup({ type: 'schedule', schedule: '', cdName: '' });
    setIsCycleMode(false);

    if (size.innerSize.W <= 1024) {
      broadRef?.current.classList.add('active');
    }
    setBroadcastRowKey('');
    setPlanRowState(emptyPlanRowState);
    setInitPlanRowState(emptyPlanRowState);
    setUseDateType(true);
    setIsUseYn(true);
    setRangeState([{ startDate: new Date(), endDate: new Date(), key: 'selection' }]);
    setIsNewBroadcast(true);
    setWeekList(INIT_WEEK_LIST);

    setIsNewSchedule(true);
    setSubPlanRowData(emptySubPlanRowState);
    setTimeList([{ timeId: v4(), beginTime: INIT_START_HMS, endTime: INIT_START_HMS }]);
    setAvailableTimeRange({ start: INIT_START_HMS, end: INIT_END_HMS });
    setAudioCheckList([]);
    setAudioFilesTableState([]);
    setSelectedScheduleGroup({ type: 'schedule', schedule: '', cdName: '' });

    const uncheck = speakerList.map((el: any) => ({ ...el, checked: false }));
    setSpeakerList(uncheck);
  };

  const onClickNewAdd = (type: string) => {
    if (type === 'newAdd') {
      if (broadcastTableState.length >= MAX_SCHEDULE_COUNT) {
        toast.warn(t(`스케줄은 최대 ${MAX_SCHEDULE_COUNT}개까지 등록 가능합니다. 예약만료된 스케줄을 삭제하거나 수정해서 사용해주세요`));
        return;
      }

      initFn();
    }
  };

  // 슬라이더 값 처리
  const handleSliderValue = (
    e: React.ChangeEvent<HTMLInputElement>, //
    dataKey: string
  ) => {
    setSubPlanRowData((prev: any) => ({
      ...prev, //
      [dataKey]: parseInt(e.target.value, 10).toString(),
    }));
  };

  // 음원 파일 - 체크리스트
  const onClickCheckSchedule = (row: any) => {
    setScheduleChkList(row);
  };

  const onClickClose = () => {
    setOpenModal((prev: IModal) => ({ ...prev, status: false }));
  };

  const onClickModalSave = async (key: number) => {
    // 0: 음원 파일 목록 전송, 1: 스케줄 음원 파일 전송
    if (key === 0) {
      if (checkList.length === 0) {
        toast.warn(t('전송할 음원 파일을 선택해주세요'));
      } else {
        // await sendAudioFiles(checkList);
        setSubPlanRowData((prev: any) => ({ ...prev, operation: { ...prev.operation, audioFiles: checkList } }));
        onClickClose();
      }
    } else if (key === 1) {
      if (audioCheckList.length === 0) {
        toast.warn(t('전송할 음원 파일을 선택해주세요'));
      } else if (audioCheckList.length > MAX_AUDIO_COUNT) {
        toast.warn(t(`음원은 최대 ${MAX_AUDIO_COUNT}개까지 추가할 수 있습니다`));
      } else {
        const newData = audioCheckList.map((item: any) => {
          return {
            ...item,
            _attributes: {}, // TUI 그리드 옵션 키 초기화
          };
        });
        setSubPlanRowData((prev: any) => ({ ...prev, operation: { ...prev.operation, audioFiles: newData } }));
        setAudioFilesTableState(newData);
        onClickClose();
      }
    }
  };

  // 음원 파일 정보 클릭
  const onClickRowAudioInfo = (rowData: any) => {
    setOpenModal((prev: any) => ({ ...prev, status: true, type: 'speakerAudioInfo', data: rowData, bsCd: rowState?.bsCd }));
  };

  const convertHM = (timeString: any[]) => {
    const hour = Number(timeString[0]);
    const min = Number(timeString[1]);

    return hour + min / 60;
  };

  const onClickcopySchedule = (copyTarget: IDaySchedule[], copyWeek: { id: number; name: string; check: boolean }[]) => {
    const copy = { ...scheduleTimeList };
    const newObj = copyTarget.map((item: IDaySchedule) => ({ ...item, id: v4() }));
    const updatedSchedule = copyContentsToSchedule(newObj, copyWeek, copy);

    setScheduleTimeList(updatedSchedule);
  };

  const copyContentsToSchedule = (copyContents: IDaySchedule[], copyWeek: { id: number; name: string; check: boolean }[], schedule: any) => {
    copyWeek.forEach((weekDay) => {
      const daySchedule = schedule.wekly.find((day: any) => day.dayOfWeek === weekDay.id);

      if (daySchedule) {
        daySchedule.scheduleList = [...copyContents];
      }
    });

    return schedule;
  };

  // 방송 스케줄 클릭
  const onClickSchedule = (el: PlanScheme) => {
    setCurrentView(INFO_VIEW);
    setSelectedScheduleGroup({ type: 'schedule', schedule: el.planSchemeID, cdName: el.planSchemeID });
    setIsNewBroadcast(false);
    setIsCycleMode(false);

    // 한 개의 요일로 제공
    /*
    const newDaySchedules =
      el?.dailyScheduleInfo !== undefined
        ? el.dailyScheduleInfo?.dailyScheduleList
        : el?.weklyScheduleInfo?.weeklyScheduleList.flatMap(({ dayOfWeek, scheduleList }: any) => scheduleList.map((schedule: any) => ({ ...schedule, dayOfWeek })));
        */

    // 여러개의 요일로 처리할 시 사용 ( 복수 기능 )
    const newDaySchedules = el?.dailyScheduleInfo !== undefined ? el.dailyScheduleInfo?.dailyScheduleList : el?.weklyScheduleInfo?.weeklyScheduleList[0].scheduleList.map((schedule: any) => schedule);

    if (newDaySchedules && newDaySchedules?.length > 0) {
      const newSchedules = newDaySchedules?.map((item: any) => ({
        type: 'schedule',
        schedule: `${getDayOfWeek(item.dayOfWeek)}${item.beginTime?.substring(0, 5)} - ${item.endTime?.substring(0, 5)}`,
        cdName: `${getDayOfWeek(item.dayOfWeek)}${item.beginTime?.substring(0, 5)} - ${item.endTime?.substring(0, 5)}`,
      }));

      setPlanRowState({
        ...planRowState,
        planSchemeID: el.planSchemeID,
        planSchemeName: el.planSchemeID,
      });

      setTimeList(newDaySchedules.map((daySchedule: any) => ({ timeId: v4(), beginTime: parseTime(daySchedule.beginTime), endTime: parseTime(daySchedule.endTime) })));
      // setSelectedTimeStart(parseTime(newDaySchedules[0].beginTime));
      // setSelectedTimeEnd(parseTime(newDaySchedules[0].endTime));
      setUseDateType(!!el.dailyScheduleInfo);
      if (el?.weklyScheduleInfo?.weeklyScheduleList[0] !== undefined) {
        setWeekList((prev: any) =>
          prev.map((week: any) => ({
            ...week,
            // checked: week.dayOfWeek === newDaySchedules[0].dayOfWeek, // 조회된 요일 중 첫번째의 요일만 제공 ( 단일 기능 )
            checked: el?.weklyScheduleInfo?.weeklyScheduleList.some((item: any) => item.dayOfWeek === week.dayOfWeek), // 여러개의 요일이 존재할 경우 사용 ( 복수 기능 )
          }))
        );
      }
      const newAudioFiles = newDaySchedules[0].operation.customAudioID.map((id: string) => DBbsfList.find((item: any) => item.customAudioID === id)).filter(Boolean);

      setSubPlanRowData({
        ...subPlanRowData,
        playMode: newDaySchedules[0].playMode || 'order',
        playNowTime: newDaySchedules[0].playNowTime || '',
        audioVolume: +newDaySchedules[0].operation.audioVolume || 100,
        operation: {
          audioLevel: +newDaySchedules[0].operation.audioLevel || 4,
          audioVolume: +newDaySchedules[0].operation.audioVolume || 100,
          customAudioID: newDaySchedules[0].operation.customAudioID,
          audioFiles: newAudioFiles,
        },
      });
      setAudioFilesTableState(newAudioFiles);
      setAudioCheckList(newAudioFiles);
    }
  };

  // 덮어쓰기 컨펌 핸들러
  const onClickCoverConfirm = () => {
    if (coverCheckList.length === 0) {
      toast.warn(t('방송 장비를 선택해주세요'));
    } else {
      setOpenModal((prev: IModal) => ({ ...prev, status: true, type: 'confirm', api: onClickCover }));
    }
  };

  // 덮어쓰기 핸들러
  const onClickCover = async () => {
    await copySetting(coverCheckList);
  };

  // 덮어쓰기 - 방송장비 전체 체크 핸들러
  const handleClickCheckAll = () => {
    if (checkAll) {
      setSettingCopyTableState((prev: any) => prev.map((el: any) => ({ ...el, checked: false })));
      setCheckAll(false);
      setCoverCheckList([]);
    } else {
      setSettingCopyTableState((prev: any) => prev.map((el: any) => ({ ...el, checked: true })));
      setCheckAll(true);
      setCoverCheckList(settingCopyTableState);
    }
  };

  // 덮어쓰기 - 방송장비 체크 핸들러
  const handleClickCheckBox = (bs: any) => {
    const listCurrentChecked = settingCopyTableState.map((el: any) => ({ ...el, checked: el.bsCd === bs.bsCd ? !el.checked : el.checked })); // 현재 체크한 방송장비 체크여부 업데이트
    const listCheckedFilter = listCurrentChecked.filter((el: any) => el.checked); // 체크되어 있는 방송장비만 필터링

    setSettingCopyTableState(listCurrentChecked);
    setCoverCheckList(listCheckedFilter);

    if (listCurrentChecked.every((el: any) => el.checked)) {
      setCheckAll(true);
    } else {
      setCheckAll(false);
    }
  };

  // 각 시간 배열에 대한 시간 변경 핸들러
  const handleTimeChange = (index: number, type: 'start' | 'end', newTime: Time) => {
    const updatedTimeList = [...timeList];
    updatedTimeList[index] = {
      ...updatedTimeList[index],
      [type === 'start' ? 'beginTime' : 'endTime']: newTime,
    };
    // 한 번만 재생(order) 모드는 종료 시간을 시작 시간 + 음원 총 재생시간으로 자동 계산
    if (type === 'start' && subPlanRowData.playMode === 'order') {
      updatedTimeList[index] = {
        ...updatedTimeList[index],
        endTime: addSecondsToTime(newTime, getTotalAudioDurationSeconds()),
      };
    }
    setTimeList(updatedTimeList);
  };

  // 시간 추가
  const onClickAddTime = () => {
    setTimeList([...timeList, { timeId: v4(), beginTime: INIT_START_HMS, endTime: INIT_START_HMS }]);
  };

  // 시간 삭제
  const handleDeleteTime = (id: string) => {
    setTimeList(timeList.filter((el: any, i) => el.timeId !== id));
  };

  // 시간 구간 생성
  const onClickCreateTimeCycle = () => {
    // 시작 시간이 종료 시간보다 큰 경우 체크
    const startTotalMinutes = selectedTimeStart.h * 60 + selectedTimeStart.m;
    const endTotalMinutes = selectedTimeEnd.h * 60 + selectedTimeEnd.m;
    const currentTimeCycle = timeCycleType === 'hour' ? timeCycle * 60 : timeCycle; // 시간일 경우 분으로 변환

    if (startTotalMinutes >= endTotalMinutes) {
      toast.warn(t('종료 시간은 시작 시간보다 커야 합니다.'));
      return;
    }

    const generatedTimeList = [];
    let currentStartTime = { ...selectedTimeStart };

    while (true) {
      // 현재 시작 시간의 총 분 계산
      const currentStartTotalMinutes = currentStartTime.h * 60 + currentStartTime.m;

      // 현재 시작 시간이 종료 시간을 넘어가면 종료
      if (currentStartTotalMinutes >= endTotalMinutes) {
        break;
      }

      // 현재 구간의 종료 시간 계산
      const endTime = {
        h: currentStartTime.h,
        m: !timeCycle ? currentStartTime.m + timeCycleMinute - 1 : currentStartTime.m + timeCycleMinute,
        s: !timeCycle ? 59 : 0,
      };

      // 분이 60을 넘어가면 시간으로 변환
      if (endTime.m >= 60) {
        endTime.h += Math.floor(endTime.m / 60);
        endTime.m %= 60;
      }

      // 생성된 시간 구간이 종료 시간을 넘어가지 않는 경우에만 추가
      const endTimeTotalMinutes = endTime.h * 60 + endTime.m;
      if (endTimeTotalMinutes <= endTotalMinutes) {
        generatedTimeList.push({
          timeId: v4(),
          beginTime: { ...currentStartTime },
          endTime,
        });
      }

      // 다음 시작 시간 계산
      currentStartTime = {
        h: currentStartTime.h,
        m: currentStartTime.m + (currentTimeCycle > timeCycleMinute ? 0 : timeCycleMinute) + currentTimeCycle,
        s: 0,
      };

      // 분이 60을 넘어가면 시간으로 변환
      if (currentStartTime.m >= 60) {
        currentStartTime.h += Math.floor(currentStartTime.m / 60);
        currentStartTime.m %= 60;
      }
    }

    // 생성된 시간 구간이 없는 경우 기본값 설정
    if (generatedTimeList.length === 0) {
      setTimeList([
        {
          timeId: v4(),
          beginTime: { h: 0, m: 0, s: 0 },
          endTime: { h: 0, m: 0, s: 0 },
        },
      ]);
    } else {
      setTimeList(generatedTimeList.slice(0, MAX_TIME_COUNT));
    }

    setIsCycleMode(false); // 반복 모드 해제
  };

  // 시간 타입 변경 핸들러
  const onChangeCycleType = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (e.target.value === 'hour') {
      setTimeCycle(1);
    }
    if (e.target.value === 'minute') {
      setTimeCycle(10);
    }

    setTimeCycleType(e.target.value as 'hour' | 'minute');
  };

  // 시간 주기 시간/분(마다) 변경 핸들러
  const onChangeCycle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const currentVal = e.target.value.replaceAll('.', '');

    if (timeCycleType === 'hour') {
      if (currentVal.length > 2) {
        setTimeCycle(Number(currentVal.slice(0, 2)));
      } else if (Number(currentVal) > 12) {
        setTimeCycle(12);
      } else {
        setTimeCycle(Number(currentVal));
      }
    }
    if (timeCycleType === 'minute') {
      if (currentVal.length > 3) {
        setTimeCycle(Number(currentVal.slice(0, 3)));
      } else {
        setTimeCycle(Number(currentVal));
      }
    }
  };

  // 시간 주기 분(씩) 변경 핸들러
  const onChangeCycleMinute = (e: React.ChangeEvent<HTMLInputElement>) => {
    const currentVal = e.target.value.replaceAll('.', '');

    if (currentVal.length > 3) {
      setTimeCycleMinute(Number(currentVal.slice(0, 3)));
    } else {
      setTimeCycleMinute(Number(currentVal));
    }
  };

  // 시간 리스트 정렬
  const onClickTimeSort = () => {
    setTimeList((prev: any) => {
      const sorted = [...prev].sort((a: any, b: any) => {
        const prevTotal = a.beginTime.h * 3600 + a.beginTime.m * 60 + a.beginTime.s;
        const nextTotal = b.beginTime.h * 3600 + b.beginTime.m * 60 + b.beginTime.s;
        return prevTotal - nextTotal;
      });

      if (subPlanRowData.playMode === 'order') {
        const totalDurationSeconds = getTotalAudioDurationSeconds();
        return sorted.map((time: any) => ({
          ...time,
          endTime: addSecondsToTime(time.beginTime, totalDurationSeconds),
        }));
      }

      return sorted;
    });
  };

  // 방송 스케줄 정보
  const renderBroadcastSubTable = () => {
    return (
      <SubRoot>
        {!canConnect && <div className='dim-loading' />}
        <div className='schedule-list'>
          <div className='schedule-list-header'>
            <div className='schedule-list-title'>{t('방송 스케줄 목록')}</div>
            {(auth.createAuth || auth.updateAuth) && (
              <div className='schedule-list-button'>
                <BtnGreen onClick={onClickCopy}>{t('스케줄 덮어쓰기')}</BtnGreen>
                <BtnGhost onClick={() => onClickNewAdd('newAdd')}>
                  <span className='material-symbols-rounded'>calendar_add_on</span>
                  {t('신규 등록')}
                </BtnGhost>
              </div>
            )}
          </div>
          <div className='schedule-list-content'>
            <div className='bs-header'>
              <div className='bs-title'>
                {t('방송 장비명')} : <span>{rowState.bsName}</span>
              </div>

              <span className='division-bar'> | </span>

              <div className='schedule-count-wrap'>
                {t('스케줄 개수')} :
                <span className='schedule-count-text'>
                  {broadcastTableState?.length} <b>/ {MAX_SCHEDULE_COUNT}</b>
                </span>
              </div>
            </div>
            {broadcastTableState?.length > 0 ? (
              broadcastTableState.map((el: PlanScheme, index: number) => (
                <div
                  className={`schedule-list-item ${selectedScheduleGroup.schedule !== '' && el.planSchemeID === selectedScheduleGroup.schedule ? 'selected' : ''}`}
                  key={index}
                  role='button'
                  tabIndex={0}
                  onClick={() => onClickSchedule(el)}
                >
                  <div className='schedule-list-item-badge'>
                    <SmallTextLabel text={el.enabled ? t('사용') : t('미사용')} color={el.enabled ? 'green' : 'slate'} />
                    <SmallTextLabel text={el.dailyScheduleInfo ? t('매일') : t('주간')} color={el.dailyScheduleInfo ? 'violet' : 'orange'} />
                  </div>
                  <div className='schedule-list-info'>
                    <div className='schedule-list-item-title'>{el.planSchemeID}</div>
                    <div className='schedule-list-item-time'>
                      <span className='material-symbols-rounded'>calendar_month</span>
                      <span>
                        {el.dailyScheduleInfo?.startTime || el.weklyScheduleInfo?.startTime} ~ {el.dailyScheduleInfo?.stopTime || el.weklyScheduleInfo?.stopTime}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <IssueGuide text='신규 등록을 통해 스케줄을 등록해주세요' type='data' />
            )}
          </div>
        </div>
        <div className='schedule-content'>
          {currentView === INFO_VIEW ? (
            <>
              <div className='schedule-list-header'>
                <div className='schedule-list-title'>{t(isNewBroadcast ? '방송 스케줄 신규 등록' : '방송 스케줄 정보')}</div>
              </div>
              <div className='schedule-content-form'>
                <TextInfoBox ico='info' description='스케줄명은 중복으로 등록할 수 없습니다.' color='red' style={{ marginBottom: '1rem' }} />

                <div className='inputForm-group-row labelOutInput'>
                  <label htmlFor='scheduleDate' className='required'>
                    {t('스케줄명')}
                  </label>
                  <Input
                    className='required'
                    type='text'
                    id='planSchemeName'
                    name='planSchemeName'
                    state={planRowState}
                    setState={setPlanRowState}
                    disabled={!auth.updateAuth}
                    inputRef={planSchemeNameRef}
                    getBorderStyle={isSaveClick ? applyBorderStyle(planRowState.planSchemeName, 'red', 'planSchemeName') : undefined}
                  />
                </div>
                <div className='inputForm-group-row'>
                  <label htmlFor='scheduleDate' className='required'>
                    {t('예약 일자')}
                  </label>
                  <div>
                    <div className='inputForm-col'>
                      <div className='flex-basic' style={{ gap: '0.5rem' }}>
                        <input id='startInput' type='text' value={dateTime.start} onMouseDown={onClickRangeInput} onChange={(e) => onChangeRangeInput(e, 'start', setRangeState, setDateTime)} />
                        <span className='inputDash'> ~ </span>
                        <input id='endInput' type='text' value={dateTime.end} onMouseDown={onClickRangeInput} onChange={(e) => onChangeRangeInput(e, 'end', setRangeState, setDateTime)} />
                      </div>
                      {visibleRangePicker && (
                        <div className='rangePickerWrapper'>
                          <RangePicker state={rangeState} setState={setRangeState} setVisible={setVisibleRangePicker} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className='inputForm-group-row'>
                  <label className='required'>{t('시간 설정')}</label>
                  <div className='flex-basic time-wrap' style={{ gap: '0.5rem' }}>
                    {!isCycleMode ? (
                      <>
                        <div className='time-header' style={{ width: subPlanRowData.playMode === 'order' ? '204px' : '320px' }}>
                          <div className='time-header-left'>
                            <div className='time-header-title'>{t('시간 목록')}</div>
                            <div className='time-header-count'>
                              {timeList.length} <b>/ {MAX_TIME_COUNT}</b>
                            </div>
                          </div>
                          <div className='time-header-right'>
                            <BtnGhost className='btn-sort' onClick={onClickTimeSort}>
                              <span className='material-symbols-rounded'>swap_vert</span>
                              {t('정렬')}
                            </BtnGhost>
                            {subPlanRowData.playMode !== 'order' && (
                              <BtnBlue className='btn-cycle' onClick={() => setIsCycleMode(!isCycleMode)}>
                                <span className='material-symbols-rounded'>manufacturing</span>
                                {t('반복 설정')}
                              </BtnBlue>
                            )}
                          </div>
                        </div>
                        <div className='time-content'>
                          {timeList.map((time: any, index: number) => (
                            <div key={time.timeId} className='time-item'>
                              <span className='time-item-index'>{index + 1}</span>
                              <div className=''>
                                <CustomTimePicker
                                  type='start'
                                  mode='input'
                                  selectedTime={time.beginTime}
                                  setSelectedTime={(newTime: any) => handleTimeChange(index, 'start', newTime)}
                                  availableTimeList={availableTime}
                                  availableTimeRange={{ start: INIT_START_HMS, end: INIT_END_HMS }}
                                  setAvailableTimeRange={setAvailableTimeRange}
                                  // invalid={isInvalidStartTime}
                                  schedules={useDateType ? scheduleTimeList?.daily : scheduleTimeList?.wekly.find((el: IWeekSchedule) => el.dayOfWeek === Number(subPlanRowData.v))?.scheduleList}
                                  isNewSchedule={isNewSchedule}
                                />
                                {subPlanRowData.playMode !== 'order' && (
                                  <>
                                    <span className='inputDash'> ~ </span>
                                    <CustomTimePicker
                                      type='end'
                                      mode='input'
                                      startTime={time.beginTime}
                                      selectedTime={time.endTime}
                                      setSelectedTime={(newTime: any) => handleTimeChange(index, 'end', newTime)}
                                      availableTimeList={availableTime}
                                      availableTimeRange={{ start: INIT_START_HMS, end: INIT_END_HMS }}
                                      setAvailableTimeRange={setAvailableTimeRange}
                                      // invalid={isInvalidEndTime}
                                      schedules={useDateType ? scheduleTimeList?.daily : scheduleTimeList?.wekly.find((el: IWeekSchedule) => el.dayOfWeek === Number(subPlanRowData.v))?.scheduleList}
                                      isNewSchedule={isNewSchedule}
                                    />
                                  </>
                                )}
                              </div>
                              {/* {index === 0 && (
                                <div className='time-item-cycle-btn'>
                                  <BtnRed onClick={() => setIsCycleMode(!isCycleMode)}>
                                    <span className='material-symbols-rounded'>manufacturing</span>
                                    {t('시간 구간 생성')}
                                  </BtnRed>
                                </div>
                              )} */}
                              {index >= 1 && (
                                <div className='time-item-delete'>
                                  <BtnRed onClick={() => handleDeleteTime(time.timeId)}>
                                    <span className='material-symbols-rounded'>remove</span>
                                  </BtnRed>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>

                        {timeList.length < MAX_TIME_COUNT && (
                          <div className='time-bottom' style={{ width: subPlanRowData.playMode === 'order' ? '204px' : '320px' }}>
                            <BtnGhost onClick={onClickAddTime}>
                              <span className='material-symbols-rounded'>add</span>
                              {t('시간 추가')}
                            </BtnGhost>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className='time-cycle-wrap'>
                        <div className='time-cycle-header'>
                          {t('반복 생성')}
                          <BtnRed onClick={() => setIsCycleMode(!isCycleMode)}>
                            <span className='material-symbols-rounded'>undo</span>
                            {t('돌아가기')}
                          </BtnRed>
                        </div>
                        <TextInfoBox
                          ico='lightbulb'
                          description={`시간은 최대 ${MAX_TIME_COUNT}개까지 가능하며 ${MAX_TIME_COUNT}개 이상인 구간들은 자동 삭제 됩니다.<br />시간 구간이 많아질수록 등록 및 수정 시 시간이 다소 걸릴 수 있습니다.<br />생성을 누르게 되면 설정된 기반으로 생성이 되며, 이전에 설정한 시간들은 사라집니다.`}
                          color='orange'
                        />
                        <div className='time-cycle-content-wrap'>
                          <div className='time-cycle-content'>
                            <label>{t('시간 범위')}</label>
                            <div className='flex-basic' style={{ gap: '0.5rem' }}>
                              <CustomTimePicker
                                type='start'
                                mode='input'
                                selectedTime={selectedTimeStart}
                                setSelectedTime={setSelectedTimeStart}
                                availableTimeList={availableTime}
                                availableTimeRange={{ start: INIT_START_HMS, end: INIT_END_HMS }}
                                setAvailableTimeRange={setAvailableTimeRange}
                                showSecond={false}
                                isNewSchedule={isNewSchedule}
                              />
                              <span className='inputDash'> ~ </span>
                              <CustomTimePicker
                                type='end'
                                mode='input'
                                // startTime={selectedTimeStart}
                                selectedTime={selectedTimeEnd}
                                setSelectedTime={setSelectedTimeEnd}
                                availableTimeList={availableTime}
                                availableTimeRange={{ start: INIT_START_HMS, end: INIT_END_HMS }}
                                setAvailableTimeRange={setAvailableTimeRange}
                                showSecond={false}
                                isNewSchedule={isNewSchedule}
                              />
                            </div>
                          </div>
                          <div className='time-cycle-content'>
                            <label>{t('범위 주기')}</label>
                            <div className='time-cycle-content-input'>
                              <div className='time-cycle-content-input-item'>
                                <select onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChangeCycleType(e)} value={timeCycleType}>
                                  <option value='hour'>{t('시간')}</option>
                                  <option value='minute'>{t('분')}</option>
                                </select>
                                <input
                                  type='number'
                                  value={timeCycle}
                                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeCycle(e)}
                                  onFocus={(e: React.FocusEvent<HTMLInputElement>) => e.target.select()}
                                />
                                <span>{t(`${timeCycleType === 'hour' ? '시간' : '분'}마다`)}</span>
                              </div>
                              <div className='time-cycle-content-input-item'>
                                <input
                                  type='number'
                                  value={timeCycleMinute}
                                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChangeCycleMinute(e)}
                                  onFocus={(e: React.FocusEvent<HTMLInputElement>) => e.target.select()}
                                />
                                <span>{t('분씩')}</span>
                              </div>
                            </div>
                          </div>

                          <div className='time-cycle-bottom'>
                            <BtnBlue onClick={onClickCreateTimeCycle}>
                              <span>
                                <b>{`${String(selectedTimeStart.h).padStart(2, '0')}:${String(selectedTimeStart.m).padStart(2, '0')}`}</b> 부터
                              </span>
                              <span>
                                <b>{`${String(selectedTimeEnd.h).padStart(2, '0')}:${String(selectedTimeEnd.m).padStart(2, '0')}`}</b> 까지
                              </span>
                              <span>
                                <b>
                                  {timeCycle}
                                  {timeCycleType === 'hour' ? '시간' : '분'}
                                </b>
                                마다
                              </span>
                              <span>
                                <b>{timeCycleMinute}분</b>씩
                              </span>
                              <span>생성</span>
                            </BtnBlue>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='inputForm-group-row'>
                  <label htmlFor='useDateType'>{t('예약 유형')}</label>
                  <div className='radio-group-row'>
                    <RadioContainer name={t('매일 지정 시간에 방송')} onClick={() => setUseDateType(true)} isSelected={useDateType} />
                    <RadioContainer name={t('요일별 지정 시간에 방송')} onClick={onClickWeeklyMode} isSelected={!useDateType} />
                  </div>
                </div>
                {!useDateType && (
                  <div className='inputForm-group-row'>
                    <label className='required'>{t('요일 선택')}</label>
                    <ActiveButtons state={weekList} setState={setWeekList} />
                  </div>
                )}
                <div className='inputForm-group-row'>
                  <label htmlFor='playMode'>{t('음원 재생 방법')}</label>
                  <div className='radio-group-row'>
                    <RadioContainer name={t('한 번만 재생')} onClick={onClickOrderMode} isSelected={subPlanRowData.playMode === 'order'} />
                    <RadioContainer name={t('연속 재생')} onClick={() => setSubPlanRowData((prev: any) => ({ ...prev, playMode: 'loop' }))} isSelected={subPlanRowData.playMode !== 'order'} />
                  </div>
                </div>
                <div className='inputForm-group-row'>
                  <label htmlFor='useDateType'>{t('사용유무')}</label>
                  <div className='radio-group-row'>
                    <RadioContainer name={t('사용')} onClick={() => setIsUseYn(true)} isSelected={isUseYn} />
                    <RadioContainer name={t('미사용')} onClick={() => setIsUseYn(false)} isSelected={!isUseYn} />
                  </div>
                </div>
                <div className='inputForm-group-row volume-slider'>
                  <SliderSettings labelName={t('음량')} data={subPlanRowData.audioVolume} dataKey='audioVolume' handleSlider={handleSliderValue} minValue={1} maxValue={200} maxWidth='50%' />
                </div>
                <div className='inputForm-group-col'>
                  <div className='flex-between'>
                    <label className='required'>
                      {t('음원 파일 선택')} ({audioFilesTableState.length}/{MAX_AUDIO_COUNT})
                    </label>
                    <div className='flex-basic buttons' style={{ gap: '0.5rem' }}>
                      <span className='total-duration'>
                        {t('총 길이')}: {secondsToHHMMSS(getPureAudioDurationSeconds())}
                      </span>
                      <BtnBlue onClick={() => onClickSave(2)}>+ {t('음원 추가')}</BtnBlue>
                    </div>
                  </div>
                  <div style={{ padding: '0.5rem 0' }}>
                    <TextInfoBox ico='lightbulb' description='드래그 앤 드롭을 지원합니다. 행 순서를 위,아래로 변경하세요' color='orange' />
                    <div className='audio-list-wrap-container'>
                      <DndProvider backend={Backend} options={{ enableMouseEvents: true }}>
                        <div className='audio-list-wrap'>
                          {audioFilesTableState.length > 0 ? (
                            audioFilesTableState.map((el: any, i: number) => (
                              <DraggableRow
                                type='bsfList'
                                key={el.bsfCd}
                                index={i}
                                el={el}
                                auth={auth}
                                moveRow={dragRow}
                                tableState={audioFilesTableState}
                                setTableState={setAudioFilesTableState}
                                setAudioPlayList={setAudioPlayList}
                              />
                            ))
                          ) : (
                            <IssueGuide text='음원 선택 목록에서 음원을 체크해주세요' />
                          )}
                        </div>
                      </DndProvider>
                    </div>
                  </div>
                </div>
              </div>
              <ButtonsWrapper className='flex-between' style={{ justifyContent: 'flex-end', paddingBottom: '0' }}>
                <div className='flex-basic' style={{ gap: '0.5rem' }}>
                  {!isNewBroadcast && <LoadButton text={t(`삭제`)} color='red' isLoading={isActionLoading.isDelete} onClick={() => onClickDeleteConfirm(activeTab)} />}
                  <LoadButton text={t(`저장`)} color='blue' isLoading={isActionLoading.isSave} onClick={() => onClickSave(activeTab)} />
                </div>
              </ButtonsWrapper>
            </>
          ) : (
            <>
              <div className='schedule-list-header'>
                <div className='schedule-list-title'>{t('스케줄 덮어쓰기')}</div>
              </div>
              <div className='schedule-content-form'>
                <TextInfoBox ico='lightbulb' description='방송장비를 체크해서 덮어쓰기 버튼을 클릭할 경우 스케줄 목록 전체가 체크된 방송장비에 덮어 씌워집니다.' color='orange' />

                <div className='cover-list-wrap'>
                  <div className='header flex-between'>
                    <div className='flex-between'>
                      <div role='button' tabIndex={0} onClick={handleClickCheckAll}>
                        <CheckBoxCircle checked={checkAll} scale />
                      </div>
                      <div className='title'>{t('방송장비명')}</div>
                    </div>
                    <div className='cover-list-count'>
                      <span>{t('체크된 방송장비 수 : ')}</span>
                      <b>{settingCopyTableState.filter((el: any) => el.checked).length}</b>
                    </div>
                  </div>
                  <div className='cover-list-cont'>
                    {settingCopyTableState.length > 0 ? (
                      settingCopyTableState.map((el: any) => (
                        <div key={el.bsCd} role='presentation' className='cover-item' onClick={() => handleClickCheckBox(el)}>
                          <CheckBoxCircle checked={el.checked} scale />
                          <div>{el.bsName}</div>
                        </div>
                      ))
                    ) : (
                      <div style={{ height: 'calc(100% - 100px)' }}>
                        <IssueGuide text='덮어쓰기 할 방송장비가 없습니다.' />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <ButtonsWrapper className='flex-between' style={{ justifyContent: 'flex-end' }}>
                <div className='flex-basic' style={{ gap: '0.5rem' }}>
                  <LoadButton text={t(`덮어쓰기`)} color='green' isLoading={isActionLoading.isCover} onClick={onClickCoverConfirm} />
                </div>
              </ButtonsWrapper>
            </>
          )}
        </div>
      </SubRoot>
    );
  };

  const loading = bsQuery.isLoading;
  if (mobile || size.innerSize.W <= 1024) {
    return (
      <SubRoot>
        <IssueGuide text={MOBILE_NOT_SUPPORT} type='mobile' />
      </SubRoot>
    );
  }
  if (bsQuery.isError) return <IssueGuide text={t('오류가 발생했습니다')} type='error' />;
  if (loading)
    return (
      <div className='centered-content'>
        <PulseLoader color='rgb(0, 122, 255)' size='10px' />
      </div>
    );

  return (
    <>
      <Root loading={loading}>
        {/*
        <SearchOptions>
          <div className='inputsWrapper' style={{ justifyContent: 'space-between' }}>
            <div className='inputForm-cont'>
              <div className='inputForm-row withLabel'>
                <label htmlFor='wWorkstatus'>{t('방송 장비명')}</label>
                <div className='inputForm-col'>
                  <SearchSelectBoxSm
                    options={bsList}
                    defaultOption={t('전체')}
                    state={bsCd}
                    setState={setBsCd}
                    stateKey='bsCd'
                    codeKey='cdName'
                    initiateKey={bsCd.bsCd}
                    filterbar='filter-1-left'
                    dropDownWidth='fit-content'
                    optionHeight='height-md'
                  />
                </div>
              </div>
              <div className='inputForm-row withLabel'>
                <label htmlFor='wWorkstatus'>{t('사용유무')}</label>
                <div className='inputForm-col'>
                  <SelectBox
                    options={useYnComCdListWithAll}
                    defaultOption={t('전체')}
                    state={searchOptionUseYn}
                    setState={setSearchOptionUseYn}
                    stateKey={COMCD_USE_YN}
                    initiateKey={searchOptionUseYn[COMCD_USE_YN]}
                  />
                </div>
              </div>
              <div className='flex-basic textBtnGroup'>
                <ShortcutButton icon='search' buttonText={t('검색')} shortcut='F9' onClick={onClickSearch} />
                <BtnGhost onClick={onClickInitiateSearchOption}>{t('초기화')}</BtnGhost>
              </div>
            </div>
          </div>
        </SearchOptions>
        */}
        <InputTable className='margin-left-05' style={{ display: 'flex', flexDirection: 'row' }}>
          <div style={{ width: '25%', height: '100%' }}>
            <BroadcastEquipList state={speakerList} onClickRow={onClickSpeakerRow} rowKey={rowKey} canConnect={canConnect} />
          </div>
          <div className='main-content-right' style={{ width: '75%' }}>
            {size !== undefined &&
              size.innerSize.W >= 1024 &&
              (rowKey !== '' ? (
                <TuiGridTwoColumnStyle style={{ height: '100%' }}>
                  {renderBroadcastSubTable()}

                  <div style={{ display: 'none' }}>
                    <div id='divPlugin' className='cctvWrapperHidden' />
                  </div>
                </TuiGridTwoColumnStyle>
              ) : (
                <Root loading={loading}>
                  <IssueGuide text={t('왼쪽 목록에서 방송장비를 선택하세요')} type='select' />
                </Root>
              ))}
            {loading && (
              <LoadingModalBackground>
                <PulseLoader className='flex-center' color='rgb(0, 122, 255)' size='1rem' />
              </LoadingModalBackground>
            )}
          </div>
        </InputTable>
      </Root>
      {(isActionLoading.isSave || isActionLoading.isDelete || isActionLoading.isCover) &&
        createPortal(<FullScreenLoading type='bounce' text={isActionLoading.isSave ? '스케줄 저장중' : isActionLoading.isDelete ? '스케줄 삭제중' : '방송 스케줄 덮어쓰기중'} />, document.body)}
      <Portal openModal={openModal?.status}>
        {openModal.type === 'musicAdd' && (
          <TableInfoMoal
            openModal={openModal}
            setOpenModal={setOpenModal}
            minWidth={65}
            title={t('음원 파일 전송 목록')}
            columns={musicAddColumns}
            tableState={bsFTableState}
            // handleCheck={onClickModalCheck}
            setChkList={setCheckList}
            handleSave={() => onClickModalSave(0)}
            handleClose={onClickClose}
            loading={modalLoading}
          />
        )}
        {openModal.type === 'settingCopy' && (
          <BsSettingCopyModal
            setOpenModal={setOpenModal}
            title={t('방송장비 목록')}
            tableState={settingCopyTableState}
            copySetting={copySetting}
            loading={copyModalLoading}
            rowState={rowState}
            copyState={copyState}
          />
        )}
        {openModal.type === 'scheduleMusicAdd' && (
          <TableInfoMoal
            openModal={openModal}
            setOpenModal={setOpenModal}
            minWidth={50}
            title={t('음원 파일 추가')}
            columns={musicAddColumns}
            tableState={DBbsfList}
            // handleCheck={onClickModalCheckAdd}
            setChkList={setAudioCheckList}
            handleSave={() => onClickModalSave(1)}
            handleClose={onClickClose}
            comparisonChkList={subPlanRowData?.operation?.audioFiles || []}
            loading={modalLoading}
          />
        )}
        {openModal.type === 'speakerAudioInfo' && (
          <SpeakerAudioInfoModal openModal={openModal} setOpenModal={setOpenModal} auth={auth} eventDetectList={eventDetectList} refetch={detectAudioListRefetch} />
        )}
        {openModal.type === 'websdk' && <WebSdkModal openModal={openModal} setOpenModal={setOpenModal} />}
        {openModal.type === 'delete' && <DeleteModal openModal={openModal} setOpenModal={setOpenModal} />}
        {openModal.type === 'confirm' && <ConfirmModal openModal={openModal} setOpenModal={setOpenModal} text={t('덮어쓰기를 하시겠습니까?')} confirmMessage={t('네')} color='green' />}
        {openModal.type === 'weeklyModeConfirm' && (
          <ConfirmModal openModal={openModal} setOpenModal={setOpenModal} text={t('요일로 전환 시 5개를 초과한 시간 설정은 삭제됩니다. 전환하시겠습니까?')} confirmMessage={t('네')} color='blue' />
        )}
        {openModal.type === 'allDaysConfirm' && (
          <ConfirmModal openModal={openModal} setOpenModal={setOpenModal} text={t('모든 요일이 선택되어 매일 스케줄로 저장됩니다. 계속하시겠습니까?')} confirmMessage={t('저장')} color='blue' />
        )}
      </Portal>
    </>
  );
};

export default BroadcastSchedule;

const Root = styled(ContentsContainerRoot)`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  > .dim-loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    cursor: wait;
  }

  > div > div {
    .textBtnGroup {
      height: 2.5rem;
      gap: 0.5rem;
      > button {
        height: inherit;
        font-size: 0.875rem;
      }

      .inputForm-row > button {
        height: 2.5rem;
        font-size: 0.875rem;
        width: fit-content;
        background-color: var(--filled-green);
      }
    }
  }

  .tab {
    height: 3rem !important;
  }

  .detect-tag {
    display: inline-block;
    padding: 2px 6px;
    font-size: 0.75rem;
    border-radius: 0.25rem;
    color: #fff;

    &.fireAudio {
      background-color: #db1919;
    }

    &.helmatAudio {
      background-color: #8e35dc;
    }
  }

  .btn-in-cell {
    height: 2rem;
    font-size: 0.875rem;
    padding-left: 0.5rem;
    padding-right: 0.75rem;
    margin: 0 auto;
    font-weight: 600;
    &:hover {
      background-color: var(--board);
    }
    .material-symbols-rounded {
      margin-right: 0.25rem;
    }
  }
  .btn-blue {
    background-color: var(--primary) !important;
    border: none !important;
    color: var(--blue-100) !important;
  }
  .btn-red {
    background-color: var(--filled-red) !important;
    border: none !important;
    color: var(--red-100) !important;
  }
  .btn-blue,
  .btn-red {
    .material-symbols-rounded {
      font-size: 1.375rem;
    }
  }

  .deviceOverview {
    width: 100%;
    padding: 0.5rem 0.75rem;
    position: sticky;
    left: 0;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    gap: 2rem;
    touch-action: none;
    @media (max-width: 767px) {
      flex-direction: column;
      gap: 0.5rem;
      align-items: flex-start;
    }
    > div:first-child {
      padding: 0.25rem 0.75rem;
      border-radius: 0.25rem;
      flex-grow: 1;
      height: 2.5rem;
      display: flex;
      align-items: center;
      background-color: var(--tonal-light);
      span {
        font-size: 0.875rem;
        color: var(--text-secondary);

        &::before {
          content: '•';
          margin: 0 0.25rem;
        }

        &:first-child::before {
          content: '';
          margin: 0;
        }

        b {
          color: var(--text-primary);
          font-weight: 500;
          margin-left: 0.5rem;
        }
      }
    }
    .namespaceEllipsis {
      max-width: 26rem;
      text-overflow: ellipsis;
      overflow: hidden;
      display: block;
      white-space: nowrap;
    }
  }

  .tableTip {
    position: sticky;
    left: 0px;
    right: 0px;
    user-select: none;
    display: flex;
    font-size: 0.875rem;
    width: 100%;
    -webkit-box-align: center;
    align-items: center;
    padding: 0.4rem 1rem;
    background-color: var(--tonal-orange);
    color: #d97706;
    gap: 0.5rem;

    .material-symbols-rounded {
      font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
      color: rgb(245, 158, 11);
    }
  }
`;

const SubRoot = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 0 0.5rem;

  .audio-list-wrap-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    min-height: 150px;
    width: 100%;
    padding: 0.5rem 0;

    .audio-list-wrap {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      /* min-height: 350px; */
    }

    .audio-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: var(--tonal);
      border-radius: 0.25rem;
      padding: 0.25rem 0.75rem;

      input[type='checkbox'] {
        margin: 0;
      }

      > div {
        display: flex;
        align-items: center;
        gap: 1rem;
      }

      .play-btn {
        > button {
          height: inherit;
          padding: 6px;
          border-radius: 50%;
          background-color: var(--tonal-blue);

          &:hover {
            background-color: var(--tonal-deep-blue);
          }

          .material-symbols-rounded {
            font-variation-settings: 'FILL' 1, 'wght' 400;
            color: var(--text-primary);
            background-color: inherit;
          }
        }
      }

      .audio-index {
        color: var(--primary);
      }

      .audio-info-cont {
        display: flex;
        flex-direction: column;

        .audio-name {
          font-size: 0.875rem;
          font-weight: 600;
        }

        .audio-info {
          font-size: 0.875rem;
        }
      }
    }

    .dg-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: var(--text-primary);
      background: var(--tonal);
      border-radius: 0.25rem;
      padding: 0.75rem 0.5rem;

      .dg-left {
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }

      span {
        color: #979797;
      }

      .dg-index {
        color: var(--primary);
      }

      .dg-remove-btn {
        width: 20px;
        height: 20px;
        padding: 0;

        span {
          font-size: 0.875rem;
          color: #fff;
        }
      }
    }
  }

  .time-wrap {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;

    .time-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 320px;

      .time-header-left {
        display: flex;
        align-items: center;
        gap: 0.5rem;

        .time-header-title {
          font-size: 0.875rem;
          color: var(--text-primary);
        }

        .time-header-count {
          font-size: 0.875rem;
          color: var(--primary);
          opacity: 1;

          b {
            opacity: 0.6;
          }
        }
      }

      .time-header-right {
        display: flex;
        align-items: center;
        gap: 0.5rem;

        > button {
          width: auto;
          height: auto;
          padding: 0.25rem 0.5rem;
          font-size: 0.875rem;
          gap: 0.25rem;

          &:hover {
            transition: all 0.3s ease-in-out;
          }

          > span.material-symbols-rounded {
            font-size: 0.875rem;
          }
        }
      }
    }

    .time-content {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      .time-item {
        display: flex;
        align-items: center;
        gap: 0.5rem;

        > .time-item-index {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 40px;
          height: 40px;
          border-radius: 0.5rem;
          background: var(--tonal);
          color: var(--primary);
        }

        > .time-item-cycle-btn {
          > button {
            width: auto;
            height: 2.5rem;
            padding: 0 0.5rem;
            background-color: var(--primary);
            font-size: 0.875rem;
            gap: 0.5rem;

            > span {
              font-size: 0.875rem;
              color: var(--white);
            }
          }
        }

        > .time-item-delete {
          > button {
            width: 20px;
            height: 20px;
            background-color: var(--filled-red);
            color: var(--btn-text);
            padding: 0;

            > span {
              font-size: 0.875rem;
              color: var(--white);
            }
          }
        }
      }
    }

    .time-bottom {
      display: flex;
      align-items: center;
      width: 320px;

      > button {
        width: 100%;
        height: 2.5rem;
        font-size: 0.875rem;
        border: 1px dashed var(--outline);

        > span {
          font-size: 0.875rem;
        }

        &:hover {
          border-color: var(--outline-em);
          background-color: var(--board);
        }
      }
    }
  }

  .time-cycle-wrap {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .time-cycle-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.875rem;
      color: var(--text-primary);
      width: 100%;
      gap: 0.5rem;

      > button {
        width: auto;
        height: auto;
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        gap: 0.25rem;

        > span {
          font-size: 0.875rem;
        }
      }
    }

    .time-cycle-content-wrap {
      width: 282px;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      .time-cycle-content-input {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .time-cycle-content-input-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: var(--text-primary);

          select {
            width: 60px;
            font-size: 0.875rem;
          }

          input {
            width: 3rem;
            text-align: center;
            padding: 0 0.5rem;
          }
        }
      }

      .time-cycle-bottom {
        display: flex;
        align-items: center;
        width: 100%;

        > button {
          width: 100%;
          height: 2.5rem;
          font-size: 0.875rem;
          gap: 0.25rem;

          > span {
            font-size: 0.875rem;

            > b {
              font-weight: 600;
            }
          }

          &:hover {
            background-color: var(--filled-blue-dark);
          }
        }
      }
    }
  }

  > .dim-loading {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(4px);
  }

  .inputForm-group-col {
    display: flex;
    flex-direction: column;
    margin-bottom: 1.25rem;

    label {
      margin-bottom: 0.4rem;
      font-size: 0.875rem;
    }

    .buttons {
      button {
        height: 2rem;
        font-size: 0.875rem;
        width: fit-content;
        padding: 0 0.5rem;
      }

      .total-duration {
        font-size: 0.875rem;
        color: var(--text-secondary);
        white-space: nowrap;
      }
    }

    .radio-group-row {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      & > div {
        justify-content: flex-start;
        width: 100%;
        padding: 0;
        margin-right: 1.25rem;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .schedule-list,
  .schedule-content {
    width: 40%;
    padding: 0 0.5rem;
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;

    .schedule-list-header {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid var(--outline);
      align-items: center;
      height: 3rem;
      margin-bottom: 0.5rem;
      padding: 0 0.5rem;

      .schedule-list-title {
        font-weight: 600;
        color: var(--text-primary);
      }

      .schedule-list-button {
        display: flex;
        flex-direction: row;
        gap: 0.5rem;

        button {
          height: 2rem;
          font-size: 0.875rem;
          width: fit-content;
          padding: 0 0.75rem;

          &:last-child {
            border: 1px solid var(--outline);
          }
        }
      }
    }

    .schedule-list-content {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      padding: 0.5rem;
      overflow-y: auto;
      height: calc(100% - 2rem);

      .bs-header {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        background-color: var(--tonal-amber);
        border-radius: 0.25rem;
        padding: 0.25rem 0.75rem;

        .bs-title {
          font-size: 0.875rem;
          color: var(--filled-amber-deep);

          span {
            font-size: 0.875rem;
            color: var(--filled-amber-deep);
            font-weight: 700;
          }
        }

        .division-bar {
          font-size: 0.875rem;
          color: var(--filled-amber-deep);
        }

        .schedule-count-wrap {
          display: flex;
          align-items: center;
          color: var(--filled-amber-deep);
          font-size: 0.875rem;
          gap: 0.5rem;

          .schedule-count-text {
            font-weight: 700;
            opacity: 1;

            > b {
              font-weight: 700;
              opacity: 0.75;
            }
          }
        }
      }

      .schedule-list-item {
        display: flex;
        flex-direction: column;
        background-color: var(--tonal-light);
        padding: 0.75rem;
        border-radius: 0.25rem;
        gap: 0.5rem;
        cursor: pointer;

        .schedule-list-item-badge {
          display: flex;
          flex-direction: row;
          gap: 0.25rem;

          > div {
            margin: 0;
            font-size: 12px;
            padding: 4px 8px;
            height: auto;

            > span {
              line-height: 1.4;
            }
          }
        }

        .schedule-list-item-title {
          font-weight: 600;
          color: var(--text-primary);
        }

        .schedule-list-item-time {
          display: flex;
          align-items: center;
          gap: 0.25rem;
          font-size: 0.875rem;
          color: var(--text-secondary);

          > span.material-symbols-rounded {
            font-variation-settings: 'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24;
            font-size: 16px;
          }
        }

        &.selected {
          background-color: var(--tonal-blue);
          outline: 2px solid var(--filled-blue-light);

          .schedule-list-item-title {
            font-weight: 700;
          }
          .schedule-list-item-title,
          .schedule-list-item-time {
            color: var(--filled-blue-deep);
          }
        }

        &:hover {
          background-color: var(--tonal-blue);
        }
      }
    }

    .schedule-content-form {
      padding: 0.5rem;
      flex: 1;
      overflow-y: auto;

      .cover-list-wrap {
        width: 100%;
        padding: 1rem 0;

        .header {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.5rem;
          border-bottom: 1px solid var(--outline);
          color: var(--text-primary);

          .cover-list-count {
            font-size: 0.875rem;
            color: var(--text-secondary);

            b {
              color: var(--primary);
            }
          }
        }

        .cover-list-cont {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          padding: 0.5rem 0;

          .cover-item {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.75rem 0.5rem;
            border-radius: 0.25rem;
            background: var(--tonal-light);
            color: var(--text-primary);
            cursor: pointer;

            &:hover {
              background: var(--tonal);
            }
          }
        }
      }

      .inputDash {
        color: var(--text-primary);
      }
    }
  }

  .schedule-content {
    width: 60%;

    input {
      height: 2.5rem;
    }
  }

  .seperator {
    margin: 0.5rem 0;
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    color: var(--text-primary);
    div {
      height: 1px;
      flex-grow: 1;
      background-color: rgba(0, 0, 0, 0.1);
    }
    span {
      border-bottom: 1px solid var(--outline);
    }
  }

  .button {
    flex-shrink: 0;
    user-select: none;
    cursor: pointer;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.25rem;
    padding: 0 0.5rem;
    margin: auto 0;
    .material-symbols-rounded {
      font-variation-settings: 'FILL' 1, 'wght' 400;
      font-size: 1.5rem;
    }
  }

  .add-button {
    background-color: var(--tonal-blue);
    color: var(--primary);
    &:hover {
      outline: 0.25rem solid var(--primary);
      &:active {
        transform: scale(0.95);
      }
    }
  }
  .delete-button {
    background-color: var(--tonal-red);
    color: var(--filled-red);
    &:hover {
      outline: 0.25rem solid var(--filled-red);
      &:active {
        transform: scale(0.95);
      }
    }
  }

  .iconBtnGroup {
    justify-content: flex-end;

    button {
      height: 2.5rem;
      font-size: 0.875rem;
    }
  }

  .flexWrapGroup {
    display: flex;
    flex-wrap: nowrap;
  }

  .flexContainer {
    display: flex;
    width: 100%;
    gap: 1rem;

    .schedule-content-form {
      flex: 1;
      min-width: 0;
    }

    .sideBody {
      flex: 1;
      min-width: 0;
    }
  }

  .half {
    > div {
      width: 50%;
    }
  }

  @media screen and (max-width: 1024px) {
    & {
      width: 200%;
    }

    .flexWrapGroup {
      display: flex;
      flex-wrap: nowrap;
      transform: translateX(0);
      transition: ease-in-out 0.3s;

      &.active {
        transform: translateX(-50%);
        transition: ease-in-out 0.3s;
      }

      .filterbar {
        top: 10rem;
        left: 70% !important;
      }
    }

    .flexContainer {
      width: 100%;

      &.leftCont {
        width: 100%;
      }
    }
  }

  .inputForm-group-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1rem;

    &.volume-slider > div {
      width: 100%;
      max-width: 100%;
    }

    label {
      min-width: 6.5rem;
      font-size: 0.875rem;
      white-space: pre-line;
      line-height: 1.4;
    }

    &.select {
      > div {
        flex-grow: 1;
      }
    }

    > div {
      width: 100%;
      > div > button {
        width: 8rem;
      }
    }

    .labelOutInput {
      width: 100%;

      div > div {
        display: flex;
        flex-direction: row;
        align-items: center;

        input {
          flex-shrink: 1;
          height: 2.5rem;
          font-size: 0.875rem;
          padding: 0px 0.5rem;
        }
      }
    }

    .radio-group-row {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      & > div {
        padding: 0;
        margin-right: 0.75rem;

        &:last-child {
          margin-right: 0;
        }
      }

      .name {
        font-size: 0.875rem;
      }
    }
  }

  .inputForm-col {
    input {
      font-size: 0.875rem;
      height: 2.5rem;
      max-width: 8rem;
      text-align: center;
    }
  }

  .calender-picker {
    width: 100%;
    /* height: 120px; */

    .calender-btn {
      gap: 0.5rem;
    }
    .BtnGroupBetween {
      justify-content: space-between;
    }
  }
`;

const ActiveButtonRoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 2.25rem;
    max-width: 3.5rem;
    width: 100%;
    padding: 2px 0;
    border-radius: 10px;
    font-size: 0.875rem;
    color: var(--zinc-400);
    background-color: var(--tonal);

    &.active {
      color: var(--text-reverse);
      background-color: var(--filled-blue-deep);
    }

    &:hover:not(.active) {
      background-color: var(--tonal-deep);
    }
  }
`;

const ActiveButtons = ({ state, setState }: any) => {
  const { t } = useTranslation();
  const onClickState = (item: any) => {
    /* 요일 단일 체크 기능 */
    /*
    const newState = state.map((el: any) => (el.day === item ? { ...el, checked: !el.checked } : { ...el, checked: false }));
    setState(newState);
    */

    /* 요일 여러개(복수 선택) 체크 기능 */
    setState((prev: any) => [...prev.map((el: any) => (el.day === item ? { ...el, checked: !el.checked } : el))]);
  };
  return (
    <ActiveButtonRoot>
      {state.map((item: any) => (
        <button type='button' key={item.day} className={item.checked ? 'active' : ''} onClick={() => onClickState(item.day)}>
          {t(item.day)}
        </button>
      ))}
    </ActiveButtonRoot>
  );
};

const ActiveBroadcastRoot = styled.div`
  height: 100%;
  max-height: inherit;
  overflow: auto;
  display: flex;
  flex-direction: column;
  flex: 0 0 40%;
  background-color: var(--board);
  position: relative;
  .header,
  .body > .list {
    background-color: var(--board);
    border-bottom: 1px solid var(--outline);
    padding: 0 1rem;
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    .seperator {
      height: 1rem;
      &::before {
        content: '•';
      }
    }
  }
  .header {
    position: sticky;
    top: 0;
    height: 3rem;
    color: var(--text-tertiary);
    justify-content: space-between;
    .title {
      display: flex;
      gap: 0 0.25rem;
      align-items: center;
      font-weight: 600;
      color: var(--text-primary);
      font-size: 1rem;
    }
  }
  .body {
    overflow: auto;
    height: 100%;
    .list {
      background-color: var(--board);
      border-bottom: 1px solid var(--outline);
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.875rem;
      padding: 0.5rem 1rem;
      gap: 1.25rem;

      &.selected {
        background-color: var(--tonal-blue);
      }

      &:hover.selectable {
        cursor: pointer;
        background-color: var(--tonal);
        .content > .text-container > .index {
          background-color: var(--tonal-deep);
        }
      }

      &:active.selectable {
        cursor: pointer;
        background-color: var(--tonal-deep);
        .content > .text-container > .index {
          background-color: var(--tonal);
        }
      }

      .content {
        display: flex;
        flex-grow: 1;
        gap: 0.5rem;
        flex-shrink: 0;

        .text-container {
          display: flex;
          flex-grow: 1;
          gap: 0.25rem;
          flex-shrink: 0;
          align-items: center;

          > :first-child {
            margin: 0 0.5rem;
          }
        }

        .index {
          display: flex;
          justify-content: center;
          align-items: center;
          min-width: 1.5rem;
          height: 1.5rem;
          background-color: var(--tonal);
          color: var(--text-tertiary);
          border-radius: 0.25rem;
          margin: 0 0.5rem;
        }

        .text {
          display: flex;
          align-items: center;
          gap: 0.25rem;
          color: var(--text-tertiary);
        }

        .badge {
          flex-shrink: 0;
          width: fit-content;
          padding: 0 0.75rem;
          display: flex;
          min-height: 2rem;
          align-items: center;
          gap: 0.375rem;
          color: var(--text-tertiary);
          background-color: var(--tonal);
          border-radius: 0.25rem;
          .bullet {
            display: flex;
            width: 0.5rem;
            height: 0.5rem;
            border-radius: 1rem;
          }
          &.black {
            background-color: var(--tonal-slate);
            color: var(--filled-slate-deep);
            .bullet {
              background-color: var(--filled-slate);
            }
          }
          &.green {
            background-color: var(--tonal-green);
            color: var(--filled-green-deep);
            .bullet {
              background-color: var(--filled-green);
            }
          }
          &.blue {
            background-color: var(--tonal-blue);
            color: var(--filled-blue-deep);
            .bullet {
              background-color: var(--primary);
            }
          }
          &.red {
            background-color: var(--tonal-red);
            color: var(--filled-red-deep);
            .bullet {
              background-color: var(--filled-red);
            }
          }
        }
      }
    }
  }
`;

type BroadcastList = {
  bsCd: string;
  bsId: string;
  bsIp: string;
  bsName: string;
  bsPwd: string;
  cName: null | string;
  checked: boolean;
  pPort: string;
  tadCd: string;
  tadName: string;
  tatCd: string;
  tatGubun: string;
  connectValue: number;
};

export const BroadcastEquipList = ({
  state,
  onClickRow,
  rowKey = null,
  canConnect,
}: {
  state: any;
  onClickRow: (rowData: any, index: number) => void;
  rowKey?: string | null;
  canConnect: boolean;
}) => {
  const { t } = useTranslation();

  const getColor = (params: any) => {
    if (params === 0 || !params) return 'slate';
    if (params === 1) return 'green';
    if (params === 2) return 'blue';
    return 'red';
  };

  const getText = (params: any) => {
    if (params === 0 || !params) return t('연결중');
    if (params === 1) return t('연결완료');
    if (params === 2) return t('방송중');
    return t('연결실패');
  };

  return (
    <ActiveBroadcastRoot>
      <div className='header'>
        <div className='title'>{t('방송장비 목록')}</div>
        <div>
          {!canConnect && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', color: 'var(--text-primary)' }}>
              <PulseLoader size={6} color='var(--text-primary)' />
              <span>{t('불러오는중')}</span>
            </div>
          )}
        </div>
      </div>
      <div className='body'>
        {state.length > 0 ? (
          state.map((el: BroadcastList, index: number) => (
            <div className={`list ${rowKey === index.toString() ? 'selected' : ''} ${el.connectValue === 1 ? 'selectable' : ''}`} role='presentation' key={index} onClick={() => onClickRow(el, index)}>
              <div className='content'>
                {/* <div className='text-container' role='button' tabIndex={0} onClick={onClickRow ? () => onClickRow(el, index) : () => handleClickCheckBox(index)}> */}
                <div className='text-container'>
                  <span className='index'>{index + 1}</span>
                  <div className='text'>{el.bsName}</div>
                </div>
              </div>
              <div className={`badge ${getColor(el.connectValue)}`}>
                <span className='bullet' />
                <SmallTextLabel text={getText(el.connectValue)} color={getColor(el.connectValue)} />
              </div>
            </div>
          ))
        ) : (
          <IssueGuide text={t('방송장비 목록이 없습니다.')} />
        )}
      </div>
    </ActiveBroadcastRoot>
  );
};
